import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';
import RecursiveDependentQuestions from '@/components/probaworkflows_base_components/RecursiveDependentQuestions/RecursiveDependentQuestions.vue';
import {
  CLEAR_FORM_PROGRESS,
  DEPARTMENT,
  DEPARTMENT_QUESTION,
  GET_APPLICATION_FORMS,
  GET_FORM_PROGRESS,
  get_headers,
  GET_PROFILE_STATUS_URL,
  GET_USER_PROFILE_DETAILS_URL,
  JOB_POSITION_QUESTION,
  normalize_user_role,
  PREVIEW_DOCUSEAL_URL,
  PREVIEW_ONBOARDING_URL,
  PUBLIC_JOB_ADVERT_URL,
  PUBLIC_JOB_CATALOG_URL,
  REFERENCE_NUMBER_QUESTION,
  REQUEST_INFO_URL,
  SAVE_FORM_PROGRESS,
  SUBMIT_APPLICATION_FORMS_ANSWERS,
  SYNC_PROFILE_ANSWERS_TO_ENTITY_FORM,
  VERIFY_SECTION_URL
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import entity_form_depquestions_mixins from '@/utils/mixins/entity_form_mixins/entity_form_depquestions_mixins';
import entity_form_files_mixin from '@/utils/mixins/entity_form_mixins/entity_form_files_mixin';
import entity_form_scroll_mixin from '@/utils/mixins/entity_form_mixins/entity_form_scroll_mixin';
import entity_form_utils_mixins from '@/utils/mixins/entity_form_mixins/entity_form_utils_mixins';
import sa_id_validation_mixin from '@/utils/mixins/sa_id_validation_mixin.js';
import save_sections from '@/utils/mixins/save_sections';
import {
  get_language_proficiency_options,
  get_official_language_options,
  map_language_selection_value,
  normalize_language_proficiency_value,
} from '@/utils/helpers/language_card_options';
import { CONTACT_FIELD_TYPES, format_phone_number, parse_single_field_phone_input, validate_contact_field, validate_phone } from '@/utils/validations/contact_validators';
import {
  validate_non_empty_string,
  validate_non_sub_zero_number
} from '@/utils/validations/validate_inputs';
import FacialBiometric from "@/views/probaworkflows_base/verification/facial_biometric/FacialBiometric.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import { reactive } from 'vue';

export default {
  name: "MultiSectionForm",
  mixins: [
    alert_mixin, save_sections,
    entity_form_scroll_mixin,
    entity_form_files_mixin, entity_form_depquestions_mixins,
    entity_form_utils_mixins,
    sa_id_validation_mixin
  ],
  components: {
    FacialBiometric,
    FilePreviewComponent,
    RecursiveDependentQuestions
  },
  data: () => ({
    is_loading_form: false,
    preview_url: null,
    user_role: null,
    current_section_index: 0,
    completed_sections: [], // track saved sections
    headers: '',
    safe_form_config: {},
    safe_form_data: reactive({}),
    request_info_note: '',
    selected_request_fields: [],
    answered_file_questions: [],
    application_form_id: null,
    active_section: null,
    active_section_name: null,
    is_submitting: false,
    file_validation_error: {},
    validation_errors: {},
    show_file_preview_modal: false,
    preview_name: '',
    preview_type: 'other',
    preview_modal: false,
    submit_attempted: false,
    show_form_preview: false,
    form_preview_url: null,
    is_preview_loading: false,
    can_preview_submission: false,
    user_identity_defaults: {},
    current_form_type_name: '',
    inline_form_notice_text: '',
    inline_form_notice_type: 'info',
    show_profile_completion_gate: false,
    profile_completion_gate_message: '',
    expect_entity_form_after_profile: false,
    profile_gate_mode: 'completed',
    is_profile_update_mode: false,
    profile_status_cache: null,
    profile_status_request: null,
    gate_can_preview: false,
    gate_entity_application_form_id: null,
    suppress_profile_gate_once: false,
    application_forms_cache: {},
    application_forms_request: {},
    preview_capability_cache: new Map(),
    preview_capability_request: new Map(),
    user_identity_defaults_loaded: false,
    user_identity_defaults_request: null,
    is_job_application: sessionStorage.getItem('entity_applying') === 'true',
    docuseal_submission_id: null,
    job_created_at: null,
    job_published_at: null,
    job_closing_at: null,
    job_age_now: Date.now(),
    job_age_timer: null,
    is_advert_dates_loading: false,
    select_field_touched: {},
    work_experience_blocks: {},
    _all_we_blocks_by_section: {},

    department_question: DEPARTMENT_QUESTION,
    job_position_question: JOB_POSITION_QUESTION,
    reference_number_question: REFERENCE_NUMBER_QUESTION,

    department_name: DEPARTMENT,
    job_position_name: null,
    reference_number_name: null,
    DOB: null,
    gender: null,
    citizenship: null,

    sa_id_validation_errors: {},
    sa_id_validation_messages: {},
    sa_id_validation_details: {},
    language_blocks: {},
    education_blocks: {},
    reference_blocks: {},
    edu_qualification_status: {},
    phone_country_codes: {},
    phone_raw_digits: {},


  }),
  computed: {
    progress_percentage() {
      if (!this.safe_form_config.sections || this.safe_form_config.sections.length <= 1) return '0%';
      return `${((this.current_section_index + 1) / this.safe_form_config.sections.length) * 100}%`;
    },

    submit_button_text() {
      if (this.is_job_application) return 'Submit Job Application';
      return 'Submit';
    },

    advert_timer_visible() {
      return Boolean(this.job_created_at || this.job_published_at || this.job_closing_at);
    },

    show_advert_timer_panel() {
      return this.is_job_application || this.advert_timer_visible;
    },

    advert_countdown_state() {
      if (!this.advert_timer_visible) return this.is_advert_dates_loading ? 'loading' : 'missing';

      const now = this.job_age_now;
      const starts_at = this.get_datetime_time(this.job_published_at || this.job_created_at);
      const ends_at = this.get_datetime_time(this.job_closing_at);

      if (starts_at && now < starts_at) return 'pending';
      if (ends_at && now > ends_at) return 'closed';
      if (ends_at) return 'open';
      return 'created';
    },

    advert_countdown_label() {
      if (this.advert_countdown_state === 'loading') return 'Loading advert dates';
      if (this.advert_countdown_state === 'missing') return 'Advert dates unavailable';
      if (this.advert_countdown_state === 'pending') return 'Opens in';
      if (this.advert_countdown_state === 'closed') return 'Closed';
      if (this.advert_countdown_state === 'open') return 'Closes in';
      return 'Created';
    },

    advert_countdown_text() {
      const state = this.advert_countdown_state;
      const now = this.job_age_now;

      if (state === 'loading') return 'Please wait...';
      if (state === 'missing') return 'Start and end dates not found';

      if (state === 'pending') {
        return this.format_duration_from_ms(this.get_datetime_time(this.job_published_at || this.job_created_at) - now);
      }

      if (state === 'open') {
        return this.format_duration_from_ms(this.get_datetime_time(this.job_closing_at) - now);
      }

      if (state === 'closed') {
        return this.format_duration_from_ms(now - this.get_datetime_time(this.job_closing_at)) + ' ago';
      }

      return this.format_duration_from_ms(now - this.get_datetime_time(this.job_created_at || this.job_published_at)) + ' ago';
    },

    advert_countdown_parts() {
      const state = this.advert_countdown_state;
      const now = this.job_age_now;
      let target_time = null;

      if (state === 'pending') {
        target_time = this.get_datetime_time(this.job_published_at || this.job_created_at);
      } else if (state === 'open') {
        target_time = this.get_datetime_time(this.job_closing_at);
      }

      if (!target_time) return null;

      const total_seconds = Math.max(0, Math.floor((target_time - now) / 1000));
      const days = Math.floor(total_seconds / 86400);
      const hours = Math.floor((total_seconds % 86400) / 3600);
      const minutes = Math.floor((total_seconds % 3600) / 60);
      const seconds = total_seconds % 60;
      const pad = (value) => String(value).padStart(2, '0');

      return {
        days: pad(days),
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds),
      };
    },

    is_last_section() {
      if (!this.safe_form_config.sections?.length) return false;
      const lastIndex = this.safe_form_config.sections.length - 1;

      // fast path: index matches
      if (this.current_section_index === lastIndex) return true;

      // DOM fallback: check if the last section is mostly visible inside the carousel
      const container = this.$refs.carousel;
      if (!container) return false;
      const lastSection = container.querySelector(`.form-wrapper[data-index="${lastIndex}"]`);
      if (!lastSection) return false;

      const containerRect = container.getBoundingClientRect();
      const rect = lastSection.getBoundingClientRect();
      const isVertical = container.scrollHeight > container.clientHeight;

      const overlap = isVertical
        ? Math.max(0, Math.min(rect.bottom, containerRect.bottom) - Math.max(rect.top, containerRect.top))
        : Math.max(0, Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left));

      const size = isVertical ? rect.height : rect.width;
      // require at least 50% visibility to count as "last"
      return size > 0 && (overlap / size) >= 0.5;
    },

    preview_blocked_by_required_confirmation() {
      const fields = this.get_all_form_fields();
      return fields.some((field) => {
        if (!field || !field.model) return false;
        const missing_options = this.get_missing_required_options(
          field,
          Reflect.get(this.safe_form_data, field.model)
        );
        return missing_options.length > 0;
      });
    }
  },
  mounted() {
    this.headers = get_headers();
    this.application_form_id = Number(
      this.$route?.query?.application_form_id || sessionStorage.getItem('application_form_id')
    ) || null;
    if (this.application_form_id) {
      sessionStorage.setItem('application_form_id', String(this.application_form_id));
      sessionStorage.setItem('entity_applying', 'true');
    }
    this.initialize_onboarding_entry();
    if (this.is_job_application) {
      this.ensure_job_age_timer();
    }

    // wait for DOM to be rendered
    this.$nextTick(() => {
      const carousel = this.$refs.carousel;
      if (!carousel) return;
      // add scroll listener with rAF debounce
      carousel.addEventListener('scroll', this._onCarouselScroll, { passive: true });
      // mobile touchend fallback after swipe
      carousel.addEventListener('touchend', this._onCarouselTouchEnd, { passive: true });
      // listen to resize (orientation change)
      window.addEventListener('resize', this._onWindowResize);
      // initial measurement
      this.handle_scroll();
    });
    // IntersectionObserver optional backup (kept for extra reliability)
    this.observe_sections();
  },
  beforeUnmount() {
    const carousel = this.$refs.carousel;
    if (carousel) {
      carousel.removeEventListener('scroll', this._onCarouselScroll);
      carousel.removeEventListener('touchend', this._onCarouselTouchEnd);
    }
    window.removeEventListener('resize', this._onWindowResize);
    // cancel any pending rAF
    if (this._scrollRaf) {
      cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = null;
    }
    if (this._touchTimeout) {
      clearTimeout(this._touchTimeout);
      this._touchTimeout = null;
    }

    if (this._observer) {
      try { this._observer.disconnect(); } catch (e) { /* ignore */ }
      this._observer = null;
    }

    if (this.job_age_timer) {
      clearInterval(this.job_age_timer);
      this.job_age_timer = null;
    }
  },
  methods: {
    ensure_job_age_timer() {
      if (this.job_age_timer) return;
      this.job_age_timer = setInterval(() => {
        this.job_age_now = Date.now();
      }, 1000);
    },

    get_datetime_time(datetime_value) {
      if (!datetime_value) return null;
      const time = new Date(datetime_value).getTime();
      return Number.isNaN(time) ? null : time;
    },

    format_duration_from_ms(ms_value) {
      const total_seconds = Math.max(0, Math.floor((Number(ms_value) || 0) / 1000));
      const days = Math.floor(total_seconds / 86400);
      const hours = Math.floor((total_seconds % 86400) / 3600);
      const minutes = Math.floor((total_seconds % 3600) / 60);
      const seconds = total_seconds % 60;

      return `${days}d  ${hours}h  ${minutes}m  ${seconds}s`;
    },

    format_advert_datetime(datetime_value) {
      if (!datetime_value) return 'Not set';

      const date = new Date(datetime_value);
      if (Number.isNaN(date.getTime())) return datetime_value;

      return date.toLocaleString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    is_current_advert_closed() {
      const closing_time = this.get_datetime_time(this.job_closing_at);
      return Boolean(closing_time && Date.now() > closing_time);
    },

    apply_advert_dates_from_payload(payload = {}) {
      if (!payload || typeof payload !== 'object') return;

      this.job_created_at = payload.advert_date_created || payload.date_created || this.job_created_at;
      this.job_published_at = payload.advert_published_date || payload.published_date || this.job_published_at;
      this.job_closing_at = payload.advert_closing_date || payload.closing_date || this.job_closing_at;

      if (this.show_advert_timer_panel) {
        this.job_age_now = Date.now();
        this.ensure_job_age_timer();
      }
    },

    read_stored_apply_value(key) {
      return sessionStorage.getItem(key) || localStorage.getItem(key) || '';
    },

    find_matching_advert_from_catalog(project_payload = {}) {
      const jobs = Array.isArray(project_payload?.jobs) ? project_payload.jobs : [];
      const stored_advert_id = Number(this.read_stored_apply_value('apply_advert_id') || 0);
      const stored_job_id = Number(this.read_stored_apply_value('apply_job_id') || 0);
      const stored_title = String(this.read_stored_apply_value('apply_job_title') || this.job_position_name || '').trim().toLowerCase();
      const stored_reference = String(this.read_stored_apply_value('apply_job_reference_number') || this.reference_number || this.reference_number_name || '').trim().toLowerCase();

      for (const job of jobs) {
        const adverts = Array.isArray(job?.adverts) ? job.adverts : [];

        for (const advert of adverts) {
          const advert_id_matches = stored_advert_id && Number(advert?.id) === stored_advert_id;
          const job_id_matches = stored_job_id && Number(job?.id) === stored_job_id;
          const reference_matches = stored_reference && String(advert?.reference_number || job?.reference_number || '').trim().toLowerCase() === stored_reference;
          const title_matches = stored_title && String(advert?.title || job?.entity_type_name || '').trim().toLowerCase() === stored_title;

          if (advert_id_matches || reference_matches || (job_id_matches && (title_matches || !stored_title))) {
            return {
              ...advert,
              advert_title: advert?.title || job?.entity_type_name || '',
            };
          }
        }
      }

      return null;
    },

    async hydrate_advert_dates_from_public_api() {
      const entity_type_id = Number(this.read_stored_apply_value('apply_job_id') || 0);
      const advert_id = Number(this.read_stored_apply_value('apply_advert_id') || 0);

      if (this.job_closing_at) return;

      this.is_advert_dates_loading = true;
      try {
        let selected_advert = null;

        if (entity_type_id) {
          const response = await axios.get(`${PUBLIC_JOB_ADVERT_URL}?entity_type_id=${entity_type_id}`);
          const adverts = Array.isArray(response.data?.data) ? response.data.data : [];
          selected_advert = adverts.find((advert) => Number(advert?.id) === advert_id) || adverts[0] || null;
        }

        if (!selected_advert || (!selected_advert.published_date && !selected_advert.closing_date)) {
          const catalog_response = await axios.get(PUBLIC_JOB_CATALOG_URL);
          const catalog_payload = catalog_response.data?.data || {};
          selected_advert = this.find_matching_advert_from_catalog(catalog_payload);
        }

        if (selected_advert) {
          this.apply_advert_dates_from_payload(selected_advert);
        }
      } catch (_) {
        // Keep the visible fallback text on the form.
      } finally {
        this.is_advert_dates_loading = false;
      }
    },

    format_elapsed_from_datetime(datetime_value, now_value = Date.now()) {
      if (!datetime_value) return '';

      const created_time = new Date(datetime_value).getTime();
      if (Number.isNaN(created_time)) return '';

      const total_minutes = Math.max(0, Math.floor((now_value - created_time) / 60000));
      const days = Math.floor(total_minutes / 1440);
      const hours = Math.floor((total_minutes % 1440) / 60);
      const minutes = total_minutes % 60;

      const day_label = days === 1 ? 'day' : 'days';
      const hour_label = hours === 1 ? 'hour' : 'hours';
      const minute_label = minutes === 1 ? 'minute' : 'minutes';

      return `${days} ${day_label} ${hours} ${hour_label} ${minutes} ${minute_label}`;
    },

    is_system_admin_role(role_value = null) {
      const normalized_role = normalize_user_role(
        role_value || this.user_role || sessionStorage.getItem('user_role')
      );
      return String(normalized_role || '').trim().toLowerCase() === 'system admin';
    },

    get_sidebar_step_label(index) {
      let current = Number(index);
      if (!Number.isInteger(current) || current < 0) return '';

      let label = '';
      do {
        label = String.fromCharCode(65 + (current % 26)) + label;
        current = Math.floor(current / 26) - 1;
      } while (current >= 0);

      return label;
    },

    // ─── Work Experience helpers ───────────────────────────

    _get_default_we_fields() {
      return [
        { label: 'Employer', key: 'employer', type: 'text', required: true, placeholder: 'Employer name', options: [] },
        { label: 'Post Held', key: 'post_held', type: 'text', required: true, placeholder: 'Job title / post held', options: [] },
        { label: 'From Month', key: 'from_month', type: 'we_month', required: true, placeholder: 'MM', options: [] },
        { label: 'From Year', key: 'from_year', type: 'we_year', required: true, placeholder: 'Select year', options: [] },
        { label: 'To Month', key: 'to_month', type: 'we_month', required: false, placeholder: 'MM', options: [] },
        { label: 'To Year', key: 'to_year', type: 'we_year', required: false, placeholder: 'Select year', options: [] },
        { label: 'Reason for Leaving', key: 'reason', type: 'textarea', required: false, placeholder: 'Reason for leaving', options: [] },
      ];
    },

    _validate_we_month(value) {
      if (value === '' || value === null || value === undefined) return true; // empty handled by required check
      const n = this._get_we_month_number(value);
      return !isNaN(n) && n >= 1 && n <= 12;
    },

    _validate_we_year(value) {
      if (value === '' || value === null || value === undefined) return true;
      const n = parseInt(value, 10);
      return !isNaN(n) && n >= 1900 && n <= 2100;
    },

    _clamp_we_month(field_model) {
      let v = Reflect.get(this.safe_form_data, field_model);
      if (v === '' || v === null || v === undefined) return;
      const month_options = this._get_we_month_options();
      const month_text = String(v).trim();
      const matched_month = month_options.find(
        option => option.value.toLowerCase() === month_text.toLowerCase() || option.text.toLowerCase() === month_text.toLowerCase()
      );

      if (matched_month) {
        Reflect.set(this.safe_form_data, field_model, matched_month.value);
        return;
      }

      const numeric_month = parseInt(String(v).replace(/\D/g, ''), 10);
      if (isNaN(numeric_month)) {
        Reflect.set(this.safe_form_data, field_model, '');
        return;
      }

      const bounded_month = Math.min(12, Math.max(1, numeric_month));
      Reflect.set(this.safe_form_data, field_model, month_options[bounded_month - 1].value);
    },

    _get_we_month_number(value) {
      if (value === '' || value === null || value === undefined) return NaN;

      const month_text = String(value).trim();
      const month_options = this._get_we_month_options();
      const month_index = month_options.findIndex(
        option => option.value.toLowerCase() === month_text.toLowerCase() || option.text.toLowerCase() === month_text.toLowerCase()
      );

      if (month_index >= 0) return month_index + 1;

      const numeric_month = parseInt(month_text, 10);
      return numeric_month;
    },

    _get_we_month_options() {
      return [
        { text: 'Jan', value: 'Jan' },
        { text: 'Feb', value: 'Feb' },
        { text: 'Mar', value: 'Mar' },
        { text: 'Apr', value: 'Apr' },
        { text: 'May', value: 'May' },
        { text: 'Jun', value: 'Jun' },
        { text: 'Jul', value: 'Jul' },
        { text: 'Aug', value: 'Aug' },
        { text: 'Sep', value: 'Sep' },
        { text: 'Oct', value: 'Oct' },
        { text: 'Nov', value: 'Nov' },
        { text: 'Dec', value: 'Dec' },
      ];
    },

    _get_we_year_options() {
      const current_year = new Date().getFullYear();
      const years = [];
      for (let y = current_year; y >= 1970; y--) {
        years.push({ text: String(y), value: String(y) });
      }
      return years;
    },

    _get_we_to_year_options(block) {
      // Only show years >= from_year
      const from_year_field = (block.fields || []).find(f => f.key === 'from_year');
      const from_year_val = from_year_field ? parseInt(Reflect.get(this.safe_form_data, from_year_field.model) || '', 10) : NaN;
      const current_year = new Date().getFullYear();
      const min_year = !isNaN(from_year_val) ? from_year_val : 1970;
      const years = [];
      for (let y = current_year; y >= min_year; y--) {
        years.push({ text: String(y), value: String(y) });
      }
      return years;
    },

    _on_we_from_changed(block) {
      // When from_year or from_month changes, clear to_year/to_month if they are now invalid
      const from_year_field = (block.fields || []).find(f => f.key === 'from_year');
      const from_month_field = (block.fields || []).find(f => f.key === 'from_month');
      const to_year_field = (block.fields || []).find(f => f.key === 'to_year');
      const to_month_field = (block.fields || []).find(f => f.key === 'to_month');

      const from_year_val = from_year_field ? parseInt(Reflect.get(this.safe_form_data, from_year_field.model) || '', 10) : NaN;
      const from_month_num = from_month_field ? this._get_we_month_number(Reflect.get(this.safe_form_data, from_month_field.model) || '') : NaN;
      const to_year_val = to_year_field ? parseInt(Reflect.get(this.safe_form_data, to_year_field.model) || '', 10) : NaN;
      const to_month_val = to_month_field ? Reflect.get(this.safe_form_data, to_month_field.model) : null;

      if (!isNaN(from_year_val) && !isNaN(to_year_val)) {
        if (to_year_val < from_year_val) {
          // to_year is before from_year — clear both
          if (to_year_field) Reflect.set(this.safe_form_data, to_year_field.model, '');
          if (to_month_field) Reflect.set(this.safe_form_data, to_month_field.model, '');
          return;
        }
        if (to_year_val === from_year_val && !isNaN(from_month_num) && to_month_val) {
          const to_month_num = this._get_we_month_number(to_month_val);
          if (!isNaN(to_month_num) && to_month_num <= from_month_num) {
            if (to_month_field) Reflect.set(this.safe_form_data, to_month_field.model, '');
          }
        }
      }
    },

    _get_we_to_month_options(block) {
      // If to_year == from_year, only show months after from_month; otherwise all months
      const from_month_field = (block.fields || []).find(f => f.key === 'from_month');
      const from_year_field = (block.fields || []).find(f => f.key === 'from_year');
      const to_year_field = (block.fields || []).find(f => f.key === 'to_year');

      const from_month_val = from_month_field ? Reflect.get(this.safe_form_data, from_month_field.model) : null;
      const from_year_val = from_year_field ? parseInt(Reflect.get(this.safe_form_data, from_year_field.model) || '', 10) : NaN;
      const to_year_val = to_year_field ? parseInt(Reflect.get(this.safe_form_data, to_year_field.model) || '', 10) : NaN;

      const all_months = this._get_we_month_options();

      // Only restrict months when to_year equals from_year
      if (!isNaN(from_year_val) && !isNaN(to_year_val) && to_year_val === from_year_val && from_month_val) {
        const from_month_num = this._get_we_month_number(from_month_val);
        if (!isNaN(from_month_num)) {
          return all_months.filter((_, idx) => idx + 1 > from_month_num);
        }
      }

      return all_months;
    },

    _get_official_language_options() {
      return get_official_language_options();
    },

    _get_language_proficiency_options() {
      return get_language_proficiency_options();
    },

    _get_reference_relationship_options() {
      return [
        'Supervisor', 'Manager', 'Lecturer', 'Colleague', 'Mentor', 'Client', 'Community Leader', 'Other'
      ].map((item) => ({ text: item, value: item }));
    },

    _get_nqf_level_options() {
      return [
        'Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5',
        'Level 6', 'Level 7', 'Level 8', 'Level 9', 'Level 10'
      ].map((item) => ({ text: item, value: item }));
    },

    _get_year_dropdown_options(start = 1970) {
      const current_year = new Date().getFullYear() + 6;
      const years = [];
      for (let y = current_year; y >= start; y--) {
        years.push({ text: String(y), value: String(y) });
      }
      return years;
    },

    get_edu_year_options() {
      const current_year = new Date().getFullYear();
      // Always assume obtained: only years up to current year.
      const years = [];
      for (let y = current_year; y >= 1960; y--) {
        years.push({ text: String(y), value: String(y) });
      }
      return years;
    },

    validate_edu_year_obtained(field) {
      if (!field || !field.model) return;
      const val = Reflect.get(this.safe_form_data, field.model);
      if (!val) {
        this.clear_validation_error(field.model);
        return;
      }
      const yr = parseInt(val, 10);
      const current_year = new Date().getFullYear();
      if (yr > current_year) {
        this.set_validation_error(field.model, 'Year obtained cannot exceed the current year');
      } else {
        this.clear_validation_error(field.model);
      }
    },

    _normalize_language_field(field) {
      let label = String(field?.label || '').trim();
      if (!label) return null;

      // Strip [LANG N] prefix if present
      const prefix_match = label.match(/^\[LANG\s+(\d+)\]\s*(.*)/i);
      let prefix_block = null;
      if (prefix_match) {
        prefix_block = parseInt(prefix_match[1], 10);
        label = prefix_match[2].trim();
      }

      const language_match = label.match(/^Language\s+(\d+)\.?$/i);
      if (language_match) {
        const bn = prefix_block || parseInt(language_match[1], 10);
        const mapped = map_language_selection_value(Reflect.get(this.safe_form_data, field.model));
        Reflect.set(this.safe_form_data, field.model, mapped.editable_value);
        Reflect.set(this.safe_form_data, `${field.model}_other`, mapped.other_value);
        return {
          ...field,
          type: 'single_select',
          options: this._get_official_language_options(),
          allows_other: true,
          other_model: `${field.model}_other`,
          key: 'language',
          block_num: bn,
          label: `Language ${bn}`,
        };
      }

      const speak_match = label.match(/^Level\s+of\s+speaking\s*\(Language\s*(\d+)\)\*?$/i);
      if (speak_match) {
        const bn = prefix_block || parseInt(speak_match[1], 10);
        Reflect.set(
          this.safe_form_data,
          field.model,
          normalize_language_proficiency_value(Reflect.get(this.safe_form_data, field.model)),
        );
        return {
          ...field,
          type: 'single_select',
          options: this._get_language_proficiency_options(),
          key: 'speaking',
          block_num: bn,
          label: 'Level of Speaking',
        };
      }

      const rw_match = label.match(/^Level\s+of\s+Reading\s+or\s+Writing\s*\(Language\s*(\d+)\)\*?$/i);
      if (rw_match) {
        const bn = prefix_block || parseInt(rw_match[1], 10);
        Reflect.set(
          this.safe_form_data,
          field.model,
          normalize_language_proficiency_value(Reflect.get(this.safe_form_data, field.model)),
        );
        return {
          ...field,
          type: 'single_select',
          options: this._get_language_proficiency_options(),
          key: 'reading_writing',
          block_num: bn,
          label: 'Level of Reading/Writing',
        };
      }

      return null;
    },

    _normalize_reference_field(field) {
      let label = String(field?.label || '').trim();
      if (!label) return null;
      const field_type = String(field?.type || '').toLowerCase();

      // Strip [REF N] prefix if present
      const prefix_match = label.match(/^\[REF\s+(\d+)\]\s*(.*)/i);
      let prefix_block = null;
      if (prefix_match) {
        prefix_block = parseInt(prefix_match[1], 10);
        label = prefix_match[2].trim();
      }

      const name_match = label.match(/^Name\s*\(Reference\s*(\d+)\)\*?$/i);
      if (name_match) {
        const bn = prefix_block || parseInt(name_match[1], 10);
        return {
          ...field,
          type: 'text',
          key: 'name',
          block_num: bn,
          label: 'Name',
        };
      }

      const relation_match = label.match(/^Relationship to you\s*\(Reference\s*(\d+)\)\*?$/i);
      if (relation_match) {
        const bn = prefix_block || parseInt(relation_match[1], 10);
        return {
          ...field,
          type: 'single_select',
          options: this._get_reference_relationship_options(),
          allows_other: true,
          other_model: `${field.model}_other`,
          key: 'relationship',
          block_num: bn,
          label: 'Relationship',
        };
      }

      const phone_match = label.match(/^Tel\.?\s*No\.?\s*\(office hours\)\s*\(Reference\s*(\d+)\)\*?$/i);
      if (phone_match) {
        const bn = prefix_block || parseInt(phone_match[1], 10);
        return {
          ...field,
          type: 'phone',
          key: 'phone',
          block_num: bn,
          label: 'Tel. No. (office hours)',
        };
      }

      const telephone_match = label.match(/^Telephone\s*\(Reference\s*(\d+)\)\*?$/i)
        || label.match(/^Phone\s*\(Reference\s*(\d+)\)\*?$/i);
      if (telephone_match || field_type === 'phone') {
        const bn = prefix_block || (telephone_match ? parseInt(telephone_match[1], 10) : 1);
        return {
          ...field,
          type: 'phone',
          key: 'phone',
          block_num: bn,
          label: 'Telephone',
        };
      }

      return null;
    },

    _normalize_education_field(field) {
      let label = String(field?.label || '').trim();
      if (!label) return null;

      // Strip [EDU N] prefix if present
      const prefix_match = label.match(/^\[EDU\s+(\d+)\]\s*(.*)/i);
      let prefix_block = null;
      if (prefix_match) {
        prefix_block = parseInt(prefix_match[1], 10);
        label = prefix_match[2].trim();
      }

      const school_match = label.match(/^Name of School\/Technical College\s*(\d+)\*?$/i);
      if (school_match) {
        const bn = prefix_block || parseInt(school_match[1], 10);
        return {
          ...field,
          type: 'text',
          key: 'institution',
          block_num: bn,
          label: 'Institution',
        };
      }

      const qualification_match = label.match(/^Name\s+of\s+qualification\s*(\d+)?\s*obtained\*?$/i);
      if (qualification_match) {
        const bn = prefix_block || parseInt(qualification_match[1], 10) || 1;
        if (!Number.isNaN(bn)) {
          return {
            ...field,
            type: 'text',
            key: 'qualification',
            block_num: bn,
            label: 'Qualification',
          };
        }
      }

      const year_obtained_match = label.match(/^Year qualification\s*(\d+)\s*was obtained\*?$/i);
      if (year_obtained_match) {
        const bn = prefix_block || parseInt(year_obtained_match[1], 10);
        return {
          ...field,
          type: 'single_select',
          options: this._get_year_dropdown_options(1960),
          key: 'year_obtained',
          block_num: bn,
          label: 'Year Obtained',
        };
      }

      const start_match = label.match(/^Start (date|year).*\s*(\d+)?\*?$/i);
      if (start_match) {
        const bn = prefix_block || parseInt(start_match[2], 10);
        if (!Number.isNaN(bn)) {
          return {
            ...field,
            type: 'single_select',
            options: this._get_year_dropdown_options(1960),
            key: 'start_year',
            block_num: bn,
            label: 'Start Year',
          };
        }
      }

      const expected_match = label.match(/^Expected (completion|date|year).*\s*(\d+)?\*?$/i);
      if (expected_match) {
        const bn = prefix_block || parseInt(expected_match[2], 10);
        if (!Number.isNaN(bn)) {
          return {
            ...field,
            type: 'single_select',
            options: this._get_year_dropdown_options(1960),
            key: 'expected_year',
            block_num: bn,
            label: 'Expected Completion Year',
          };
        }
      }

      const nqf_match = label.match(/NQF\s*Level\s*(\d+)?/i);
      if (nqf_match) {
        const bn = prefix_block || parseInt(nqf_match[1], 10);
        if (!Number.isNaN(bn)) {
          return {
            ...field,
            type: 'single_select',
            options: this._get_nqf_level_options(),
            key: 'nqf_level',
            block_num: bn,
            label: 'NQF Level',
          };
        }
      }

      return null;
    },

    _init_structured_card_sections() {
      this._all_language_blocks_by_section = this._all_language_blocks_by_section || {};
      this._all_education_blocks_by_section = this._all_education_blocks_by_section || {};
      this._all_reference_blocks_by_section = this._all_reference_blocks_by_section || {};

      this.safe_form_config.sections.forEach((section) => {
        const all_fields = section.fields || [];
        if (!all_fields.length) return;

        const language_map = Object.create(null);
        const education_map = Object.create(null);
        const reference_map = Object.create(null);
        const leftover_fields = [];

        all_fields.forEach((field) => {
          const lang = this._normalize_language_field(field);
          if (lang) {
            const existing = Reflect.get(language_map, lang.block_num) || [];
            existing.push(lang);
            Reflect.set(language_map, lang.block_num, existing);
            return;
          }

          const ref = this._normalize_reference_field(field);
          if (ref) {
            const existing = Reflect.get(reference_map, ref.block_num) || [];
            existing.push(ref);
            Reflect.set(reference_map, ref.block_num, existing);
            return;
          }

          const edu = this._normalize_education_field(field);
          if (edu) {
            const existing = Reflect.get(education_map, edu.block_num) || [];
            existing.push(edu);
            Reflect.set(education_map, edu.block_num, existing);
            return;
          }

          leftover_fields.push(field);
        });

        const build_blocks = (map, prefix) => Object.keys(map).map(Number).sort((a, b) => a - b).map((num, idx) => ({
          index: idx,
          block_num: num,
          label: `${prefix} ${idx + 1}`,
          fields: Reflect.get(map, num) || [],
        }));

        const language_blocks = build_blocks(language_map, 'Language');
        const education_blocks = build_blocks(education_map, 'Qualification');
        const reference_blocks = build_blocks(reference_map, 'Reference');

        // Store ALL blocks so we can add/remove like work experience
        const pick_visible = (all_blocks) => {
          const visible = [];
          all_blocks.forEach(block => {
            const has_data = block.fields.some(f => {
              const v = Reflect.get(this.safe_form_data, f.model);
              return v !== '' && v !== null && v !== undefined;
            });
            if (has_data || visible.length === 0) {
              visible.push(block);
            }
          });
          return visible;
        };

        if (language_blocks.length) {
          Reflect.set(this._all_language_blocks_by_section, section.id, language_blocks);
          Reflect.set(this.language_blocks, section.id, pick_visible(language_blocks));
        }
        if (education_blocks.length) {
          Reflect.set(this._all_education_blocks_by_section, section.id, education_blocks);
          Reflect.set(this.education_blocks, section.id, pick_visible(education_blocks));
        }
        if (reference_blocks.length) {
          Reflect.set(this._all_reference_blocks_by_section, section.id, reference_blocks);
          Reflect.set(this.reference_blocks, section.id, pick_visible(reference_blocks));
        }

        section.has_language_cards = language_blocks.length > 0;
        section.has_education_cards = education_blocks.length > 0;
        section.has_reference_cards = reference_blocks.length > 0;
        section.fields = leftover_fields;
      });
    },

    _get_we_date_error(section_id, block_index) {
      const blocks = Reflect.get(this.work_experience_blocks, section_id);
      if (!blocks || !blocks[block_index]) return '';
      const block = blocks[block_index];
      if (block.currently_work_here) return '';

      const field_map = Object.create(null);
      block.fields.forEach((f) => {
        Reflect.set(field_map, f.key || f.label, f);
      });

      const fm = Reflect.get(this.safe_form_data, (Reflect.get(field_map, 'from_month') || Reflect.get(field_map, 'From Month') || {}).model) || '';
      const fy = Reflect.get(this.safe_form_data, (Reflect.get(field_map, 'from_year') || Reflect.get(field_map, 'From Year') || {}).model) || '';
      const tm = Reflect.get(this.safe_form_data, (Reflect.get(field_map, 'to_month') || Reflect.get(field_map, 'To Month') || {}).model) || '';
      const ty = Reflect.get(this.safe_form_data, (Reflect.get(field_map, 'to_year') || Reflect.get(field_map, 'To Year') || {}).model) || '';

      if (!fm || !fy || !tm || !ty) return '';

      const from_y = parseInt(fy, 10);
      const from_m = this._get_we_month_number(fm);
      const to_y = parseInt(ty, 10);
      const to_m = this._get_we_month_number(tm);

      if (isNaN(from_y) || isNaN(from_m) || isNaN(to_y) || isNaN(to_m)) return '';

      if (to_y < from_y || (to_y === from_y && to_m < from_m)) {
        return 'End date cannot be before start date';
      }
      return '';
    },

    _normalize_we_field(field) {
      // Map DB-created WE questions (with [WE N] prefix) to the correct input types
      // Only accept the numbered format [WE 1], [WE 2], [WE 3] — skip old [WE] format
      const label = field.label || '';
      const match = label.match(/^\[WE\s+(\d+)\]\s*(.*)/i);
      if (!match) return null;

      const we_block = parseInt(match[1], 10);
      const raw_label = match[2];
      const lower = raw_label.toLowerCase();

      let type = field.type;
      let key = raw_label.toLowerCase().replace(/\s+/g, '_');
      let placeholder = field.placeholder || raw_label;

      if (lower.includes('month')) {
        type = 'we_month';
        placeholder = 'MM';
      } else if (lower.includes('year')) {
        type = 'we_year';
        placeholder = 'Select year';
      } else if (lower.includes('reason')) {
        type = 'textarea';
        placeholder = 'Reason for leaving';
      } else if (lower.includes('employer')) {
        type = 'text';
        placeholder = 'Enter employer name';
      } else if (lower.includes('post') || lower.includes('held')) {
        type = 'text';
        placeholder = 'Enter job title / position held';
      } else if (type === 'number' || type === 'short_text') {
        type = 'text';
        placeholder = raw_label;
      }

      return { ...field, label: raw_label, type, key, placeholder, we_block };
    },

    _has_populated_work_experience_value(field) {
      const raw_value = Reflect.get(this.safe_form_data, field?.model);
      const normalized_value = String(raw_value ?? '').trim();
      return normalized_value && normalized_value.toLowerCase() !== 'not provided';
    },

    _is_currently_work_field(field) {
      const lower_label = String(field?.label || '').toLowerCase();
      const lower_key = String(field?.key || '').toLowerCase();
      return lower_label.includes('currently work') || lower_key.includes('currently_work');
    },

    _is_truthy_current_work_value(field) {
      const truthy_values = ['yes', 'true', '1', 'current', 'currently employed'];
      const raw_value = Reflect.get(this.safe_form_data, field?.model);
      return truthy_values.includes(String(raw_value ?? '').trim().toLowerCase());
    },

    _is_work_experience_to_field(field) {
      const lower_label = String(field?.label || '').toLowerCase();
      const lower_key = String(field?.key || '').toLowerCase();
      return lower_label.startsWith('to ') || lower_key.startsWith('to_');
    },

    _infer_currently_work_here_from_block(fields = []) {
      if (!Array.isArray(fields) || !fields.length) return false;

      let explicit_current_flag = false;
      let has_to_date_value = false;
      let has_non_to_value = false;

      fields.forEach((field) => {
        if (!this._has_populated_work_experience_value(field)) return;

        if (this._is_currently_work_field(field)) {
          explicit_current_flag = this._is_truthy_current_work_value(field) || explicit_current_flag;
          return;
        }

        if (this._is_work_experience_to_field(field)) {
          has_to_date_value = true;
          return;
        }

        has_non_to_value = true;
      });

      if (explicit_current_flag) return true;
      return !has_to_date_value && has_non_to_value;
    },

    _init_work_experience_sections() {
      this.safe_form_config.sections.forEach(section => {
        if (!section.is_work_experience) return;

        const all_fields = section.fields || [];
        if (!all_fields.length) return;

        // Normalize all WE fields and group by block number (1, 2, 3)
        const blocks_map = Object.create(null);
        const non_we_fields = [];
        const we_keywords = /employer|post\s*held|month|year|reason\s*for\s*leaving|currently\s*work/i;
        all_fields.forEach(f => {
          const norm = this._normalize_we_field(f);
          if (!norm) {
            // Exclude any field whose label looks like it should be WE (has WE prefix or WE keywords)
            // so only genuinely non-WE additional questions remain
            const label = f.label || '';
            if (/^\[WE/i.test(label) || we_keywords.test(label)) return;
            non_we_fields.push(f);
            return;
          }
          const bn = norm.we_block;
          const existing = Reflect.get(blocks_map, bn) || [];
          existing.push(norm);
          Reflect.set(blocks_map, bn, existing);
        });

        const block_nums = Object.keys(blocks_map).map(Number).sort();
        if (!block_nums.length) return;

        // Build block objects — each block uses its OWN DB questions
        const all_blocks = block_nums.map((num, idx) => ({
          index: idx,
          block_num: num,
          label: `Experience ${idx + 1}`,
          fields: Reflect.get(blocks_map, num) || [],
          currently_work_here: this._infer_currently_work_here_from_block(Reflect.get(blocks_map, num) || []),
        }));

        const template_block = all_blocks[all_blocks.length - 1];
        while (template_block && all_blocks.length < 50) {
          const next_index = all_blocks.length;
          const next_block_num = next_index + 1;
          all_blocks.push({
            index: next_index,
            block_num: next_block_num,
            label: `Experience ${next_block_num}`,
            fields: (template_block.fields || []).map((field) => {
              const model = `we_${section.id}_${next_block_num}_${field.key || field.model}`;
              if (!Reflect.has(this.safe_form_data, model)) {
                Reflect.set(this.safe_form_data, model, '');
              }
              return {
                ...field,
                model,
                id: model,
                section_question_id: null,
              };
            }),
            currently_work_here: false,
          });
        }

        // Show blocks that already have answer data, minimum 1
        const visible = [];
        all_blocks.forEach(block => {
          const has_data = block.fields.some(f => {
            const v = Reflect.get(this.safe_form_data, f.model);
            return v !== '' && v !== null && v !== undefined;
          });
          if (has_data || visible.length === 0) {
            visible.push(block);
          }
        });

        // Store ALL blocks for add/remove operations
        this._all_we_blocks_by_section = this._all_we_blocks_by_section || {};
        Reflect.set(this._all_we_blocks_by_section, section.id, all_blocks);

        Reflect.set(this.work_experience_blocks, section.id, visible);

        // Keep non-WE questions in the normal section rendering
        section.fields = non_we_fields;
      });
    },

    add_experience_block(section_id) {
      const all = Reflect.get((this._all_we_blocks_by_section || {}), section_id) || [];
      const visible = Reflect.get(this.work_experience_blocks, section_id) || [];
      if (visible.length >= all.length) {
        this.show_error(`Maximum of ${all.length} experience blocks allowed`);
        return;
      }

      const next_block = all[visible.length];
      next_block.label = `Experience ${visible.length + 1}`;
      visible.push(next_block);
    },

    remove_experience_block(section_id, block_index) {
      const blocks = Reflect.get(this.work_experience_blocks, section_id);
      if (!blocks || blocks.length <= 1) return;

      // Clear form data for the removed block
      const removed = blocks[block_index];
      if (removed) {
        removed.fields.forEach(f => {
          Reflect.set(this.safe_form_data, f.model, '');
        });
        removed.currently_work_here = false;
      }

      blocks.splice(block_index, 1);

      // Re-label remaining blocks
      blocks.forEach((b, i) => { b.label = `Experience ${i + 1}`; });
    },

    add_language_block(section_id) {
      const all = Reflect.get((this._all_language_blocks_by_section || {}), section_id) || [];
      const visible = Reflect.get(this.language_blocks, section_id) || [];
      if (visible.length >= all.length) {
        this.show_error(`Maximum of ${all.length} language blocks allowed`);
        return;
      }
      const next_block = all[visible.length];
      next_block.label = `Language ${visible.length + 1}`;
      visible.push(next_block);
    },

    remove_language_block(section_id, block_index) {
      const blocks = Reflect.get(this.language_blocks, section_id);
      if (!blocks || blocks.length <= 1) return;
      const removed = blocks[block_index];
      if (removed) {
        removed.fields.forEach(f => {
          Reflect.set(this.safe_form_data, f.model, '');
          if (f.other_model) Reflect.set(this.safe_form_data, f.other_model, '');
        });
      }
      blocks.splice(block_index, 1);
      blocks.forEach((b, i) => { b.label = `Language ${i + 1}`; });
    },

    add_education_block(section_id) {
      const all = Reflect.get((this._all_education_blocks_by_section || {}), section_id) || [];
      const visible = Reflect.get(this.education_blocks, section_id) || [];
      if (visible.length >= all.length) {
        this.show_error(`Maximum of ${all.length} qualification blocks allowed`);
        return;
      }
      const next_block = all[visible.length];
      next_block.label = `Qualification ${visible.length + 1}`;
      visible.push(next_block);
    },

    remove_education_block(section_id, block_index) {
      const blocks = Reflect.get(this.education_blocks, section_id);
      if (!blocks || blocks.length <= 1) return;
      const removed = blocks[block_index];
      if (removed) {
        removed.fields.forEach(f => {
          Reflect.set(this.safe_form_data, f.model, '');
        });
      }
      blocks.splice(block_index, 1);
      blocks.forEach((b, i) => { b.label = `Qualification ${i + 1}`; });
    },

    add_reference_block(section_id) {
      const all = Reflect.get((this._all_reference_blocks_by_section || {}), section_id) || [];
      const visible = Reflect.get(this.reference_blocks, section_id) || [];
      if (visible.length >= all.length) {
        this.show_error(`Maximum of ${all.length} reference blocks allowed`);
        return;
      }
      const next_block = all[visible.length];
      next_block.label = `Reference ${visible.length + 1}`;
      visible.push(next_block);
    },

    remove_reference_block(section_id, block_index) {
      const blocks = Reflect.get(this.reference_blocks, section_id);
      if (!blocks || blocks.length <= 1) return;
      const removed = blocks[block_index];
      if (removed) {
        removed.fields.forEach(f => {
          Reflect.set(this.safe_form_data, f.model, '');
          if (f.other_model) Reflect.set(this.safe_form_data, f.other_model, '');
        });
      }
      blocks.splice(block_index, 1);
      blocks.forEach((b, i) => { b.label = `Reference ${i + 1}`; });
    },

    toggle_currently_work_here(section_id, block_index) {
      const blocks = Reflect.get(this.work_experience_blocks, section_id);
      const block = Array.isArray(blocks) ? blocks.at(block_index) : null;
      if (!block) return;
      const new_val = !block.currently_work_here;
      // Only one block can be "currently work here" at a time
      if (new_val) {
        blocks.forEach((b, i) => { if (i !== block_index) b.currently_work_here = false; });
      }
      block.currently_work_here = new_val;
      // Clear To Month/To Year values and validation errors when toggling on
      if (new_val) {
        block.fields.forEach((f) => {
          if (f.label && f.label.toLowerCase().startsWith('to ')) {
            Reflect.set(this.safe_form_data, f.model, '');
            Reflect.deleteProperty(this.validation_errors, f.model);
          }
        });
      }
    },

    _collect_work_experience_answers(section) {
      const blocks = Reflect.get(this.work_experience_blocks, section.id);
      if (!blocks) return [];

      const answers = [];
      blocks.forEach(block => {
        block.fields.forEach(field => {
          if (!field.section_question_id) return;
          const val = Reflect.get(this.safe_form_data, field.model);
          answers.push({
            section_question_id: field.section_question_id,
            answer_text: (val || '').toString().trim(),
          });
        });
      });
      return answers;
    },

    _collect_work_experience_data(section) {
      const blocks = Reflect.get(this.work_experience_blocks, section.id);
      if (!blocks) return {};

      return {
        [section.id]: blocks.map((block, index) => {
          const row = {
            index,
            block_num: block.block_num || index + 1,
            currently_work_here: Boolean(block.currently_work_here),
          };
          (block.fields || []).forEach((field) => {
            row[field.key || field.label || field.model] = (
              Reflect.get(this.safe_form_data, field.model) || ''
            ).toString().trim();
          });
          return row;
        }),
      };
    },

    _get_structured_section_blocks(section_id) {
      return [
        ...(Reflect.get(this.language_blocks, section_id) || []),
        ...(Reflect.get(this.education_blocks, section_id) || []),
        ...(Reflect.get(this.reference_blocks, section_id) || []),
      ];
    },

    _is_language_identity_field(field) {
      return Boolean(field && field.key === 'language');
    },

    _get_selected_language_values_for_section(section_id, { exclude_model = null } = {}) {
      const blocks = Reflect.get(this.language_blocks, section_id) || [];
      const selected = new Set();

      blocks.forEach((block) => {
        (block.fields || []).forEach((field) => {
          if (!this._is_language_identity_field(field)) return;
          if (exclude_model && field.model === exclude_model) return;

          const raw_value = Reflect.get(this.safe_form_data, field.model);
          const normalized_value = String(raw_value || '').trim().toLowerCase();
          if (!normalized_value) return;

          selected.add(normalized_value);
        });
      });

      return selected;
    },

    _get_language_field_options(section_id, field) {
      const base_options = Array.isArray(field?.options) ? field.options : [];
      if (!section_id || !this._is_language_identity_field(field)) {
        return base_options;
      }

      const selected_elsewhere = this._get_selected_language_values_for_section(section_id, {
        exclude_model: field.model,
      });
      const current_value = String(Reflect.get(this.safe_form_data, field.model) || '').trim().toLowerCase();

      return base_options.filter((option) => {
        const option_value = String(option?.value ?? option?.text ?? '').trim();
        if (!option_value) return false;

        const normalized_option = option_value.toLowerCase();
        if (current_value && normalized_option === current_value) return true;

        return !selected_elsewhere.has(normalized_option);
      });
    },

    _validate_unique_languages(section) {
      const errors = {};
      const blocks = Reflect.get(this.language_blocks, section.id) || [];
      const seen_models_by_language = new Map();

      blocks.forEach((block) => {
        (block.fields || []).forEach((field) => {
          if (!this._is_language_identity_field(field)) return;

          const value = String(Reflect.get(this.safe_form_data, field.model) || '').trim();
          if (!value) return;

          const normalized = value.toLowerCase();
          const first_model = seen_models_by_language.get(normalized);
          if (!first_model) {
            seen_models_by_language.set(normalized, field.model);
            return;
          }

          Reflect.set(errors, first_model, 'This language is already selected in another language input');
          Reflect.set(errors, field.model, 'This language is already selected in another language input');
        });
      });

      return errors;
    },

    _collect_structured_section_answers(section) {
      const blocks = this._get_structured_section_blocks(section.id);
      if (!blocks.length) return [];

      const answers = [];
      blocks.forEach((block) => {
        (block.fields || []).forEach((field) => {
          let value = Reflect.get(this.safe_form_data, field.model);

          if (field.allows_other && String(value || '').toLowerCase() === 'other') {
            const other_value = Reflect.get(this.safe_form_data, field.other_model);
            if (other_value && String(other_value).trim()) {
              value = String(other_value).trim();
            }
          }

          if (field.type === 'single_select' || field.type === 'multi_select' || field.type === 'radio') {
            const answer_text = this.get_choice_text_from_value(field, value);
            answers.push({
              section_question_id: field.section_question_id,
              answer_text: answer_text,
            });
            return;
          }

          answers.push({
            section_question_id: field.section_question_id,
            answer_text: (value || '').toString().trim(),
          });
        });
      });

      return answers;
    },

    validate_structured_section_required(section) {
      const errors = {};
      const blocks = this._get_structured_section_blocks(section.id);
      if (!blocks.length) return errors;

      blocks.forEach((block) => {
        (block.fields || []).forEach((field) => {
          let value = Reflect.get(this.safe_form_data, field.model);

          if (field.allows_other && String(value || '').toLowerCase() === 'other') {
            const other_value = Reflect.get(this.safe_form_data, field.other_model);
            if (!other_value || !String(other_value).trim()) {
              Reflect.set(errors, field.other_model, 'Please specify other value');
            } else {
              value = other_value;
            }
          }

          if (field.required && !this.has_required_value(value)) {
            Reflect.set(errors, field.model, 'This field is mandatory');
          }
        });
      });

      if (section.has_language_cards || section.is_language) {
        Object.assign(errors, this._validate_unique_languages(section));
      }

      return errors;
    },

    get_first_error_target(errors = {}) {
      const carousel = this.$refs.carousel;
      if (!carousel || !errors || typeof errors !== 'object') return null;

      const error_models = new Set(
        Object.keys(errors).filter((key) => Boolean(Reflect.get(errors, key)))
      );
      if (!error_models.size) return null;

      const field_nodes = Array.from(carousel.querySelectorAll('[data-field-model]'));
      const target_node = field_nodes.find((node) => {
        const dataset = node ? Reflect.get(node, 'dataset') : null;
        const model = dataset ? Reflect.get(dataset, 'fieldModel') : null;
        return model && error_models.has(model);
      });

      if (!target_node) return null;

      const section_wrapper = target_node.closest('.form-wrapper');
      const section_dataset = section_wrapper ? Reflect.get(section_wrapper, 'dataset') : null;
      const raw_section_index = section_dataset ? Reflect.get(section_dataset, 'index') : null;
      const section_index = Number(raw_section_index);

      return {
        model: Reflect.get(Reflect.get(target_node, 'dataset') || {}, 'fieldModel'),
        section_index: Number.isNaN(section_index) ? null : section_index,
      };
    },

    async focus_first_error(errors = {}) {
      const target = this.get_first_error_target(errors);
      if (!target) return false;

      if (
        Number.isInteger(target.section_index)
        && target.section_index !== this.current_section_index
      ) {
        this.current_section_index = target.section_index;
        await this.$nextTick();
        this.scroll_to_section(target.section_index);
        await new Promise((resolve) => setTimeout(resolve, 650));
      } else {
        await this.$nextTick();
      }

      const carousel = this.$refs.carousel;
      const field_node = carousel?.querySelector(
        `[data-field-model="${target.model}"]`
      );
      if (!field_node) return false;

      field_node.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

      const focus_target = field_node.matches('input, select, textarea, button, [tabindex]')
        ? field_node
        : field_node.querySelector('input, select, textarea, button, [tabindex]');

      if (focus_target && typeof focus_target.focus === 'function') {
        focus_target.focus({ preventScroll: true });
      }

      return true;
    },

    add_structured_block(section_id, type) {
      const map = type === 'language'
        ? this.language_blocks
        : (type === 'education' ? this.education_blocks : this.reference_blocks);

      const blocks = Reflect.get(map, section_id) || [];
      if (!blocks.length) return;

      const max_blocks = type === 'language' ? 5 : (type === 'education' ? 50 : 3);
      if (blocks.length >= max_blocks) {
        this.show_error(`Maximum of ${max_blocks} ${type} cards allowed`);
        return;
      }
    },

    remove_structured_block(section_id, type, block_index) {
      const map = type === 'language'
        ? this.language_blocks
        : (type === 'education' ? this.education_blocks : this.reference_blocks);

      const blocks = Reflect.get(map, section_id) || [];
      if (!blocks || blocks.length <= 1 || !blocks[block_index]) return;

      const removed = blocks[block_index];
      (removed.fields || []).forEach((field) => {
        Reflect.set(this.safe_form_data, field.model, '');
        if (field.other_model) {
          Reflect.set(this.safe_form_data, field.other_model, '');
        }
      });

      blocks.splice(block_index, 1);
      blocks.forEach((block, idx) => {
        const prefix = type === 'language' ? 'Language' : (type === 'education' ? 'Qualification' : 'Reference');
        block.label = `${prefix} ${idx + 1}`;
      });
    },
    // ─── End Work Experience helpers ───────────────────────

    async initialize_onboarding_entry() {
      const is_profile_route = this.$route?.path?.startsWith('/profile_view');
      if (is_profile_route) {
        await this.get_form_to_preview();
        return;
      }

      const pending_application_form_id = Number(
        this.application_form_id || sessionStorage.getItem('application_form_id')
      ) || null;

      // Job applications already know which form should open next, so avoid
      // blocking first paint on an additional profile-status round trip.
      if (this.is_job_application && pending_application_form_id) {
        await this.get_form_to_preview();
        return;
      }

      const profile_status = await this.fetch_profile_status();
      const is_profile_completed = Boolean(profile_status?.profile_completed);

      // On job-application entry, skip gate and go straight to entity form when profile is completed.
      if (is_profile_completed) {
        await this.proceed_to_complete_application();
        return;
      }

      await this.get_form_to_preview();
    },

    async go_back() {
      if (this.show_form_preview) {
        this.exit_preview();
        return;
      }

      const has_form_loaded = Boolean(this.safe_form_config?.sections?.length);
      if (has_form_loaded) {
        const profile_status = await this.fetch_profile_status();
        const is_profile_completed = Boolean(profile_status?.profile_completed);

        if (is_profile_completed) {
          this.show_profile_completion_gate = true;
          this.profile_gate_mode = 'choice';
          this.profile_completion_gate_message =
            'Your profile is already completed. You can review and update it before continuing with this job application, or proceed directly.';
          this.show_form_preview = false;
          this.is_profile_update_mode = false;
          this.expect_entity_form_after_profile = false;
          this.suppress_profile_gate_once = false;
          await this.prepare_gate_actions();
          return;
        }
      }

      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/'); // fallback route
      }
    },
    logout() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/');

    },
    set_inline_form_notice(message, type = 'info') {
      this.inline_form_notice_text = String(message || '').trim();
      this.inline_form_notice_type = type || 'info';
    },

    clear_inline_form_notice() {
      this.inline_form_notice_text = '';
      this.inline_form_notice_type = 'info';
    },

    async proceed_to_complete_application() {
      this.show_profile_completion_gate = false;
      this.profile_completion_gate_message = '';
      this.profile_gate_mode = 'completed';
      this.is_profile_update_mode = false;
      this.expect_entity_form_after_profile = true;
      this.suppress_profile_gate_once = true;

      if (this.current_form_type_name === 'entity form' && this.safe_form_config?.sections?.length) {
        this.expect_entity_form_after_profile = false;
        return true;
      }

      const did_load_form = await this.get_form_to_preview();

      if (!did_load_form || this.current_form_type_name !== 'entity form') {
        this.show_profile_completion_gate = true;
        this.profile_gate_mode = 'choice';
        this.profile_completion_gate_message = 'Profile completed. Waiting for your Entity Form assignment. Please click Proceed again in a moment.';
        this.suppress_profile_gate_once = false;
        await this.prepare_gate_actions();
        return false;
      }

      this.expect_entity_form_after_profile = false;
      return true;
    },

    async view_and_update_profile() {
      this.show_profile_completion_gate = false;
      this.profile_completion_gate_message = '';
      this.profile_gate_mode = 'choice';
      this.is_profile_update_mode = true;
      this.expect_entity_form_after_profile = false;

      const did_load_form = await this.get_form_to_preview();
      if (!did_load_form || this.current_form_type_name !== 'profile form') {
        this.is_profile_update_mode = false;
        this.show_profile_completion_gate = true;
        this.profile_gate_mode = 'choice';
        this.profile_completion_gate_message = 'Profile form is not available right now. Please proceed to complete application.';
      }
    },

    normalize_form_type_name(value) {
      return String(value || '').trim().toLowerCase().replace(/_/g, ' ');
    },

    is_profile_form_type(value) {
      const normalized = this.normalize_form_type_name(value);
      return ['profile form', 'profile', 'system profile', 'profile information'].includes(normalized);
    },

    is_entity_form_type(value) {
      return this.normalize_form_type_name(value) === 'entity form';
    },

    get_application_forms_cache_key({ profile = false } = {}) {
      if (profile) {
        return 'profile';
      }

      const current_application_form_id = Number(
        this.application_form_id || sessionStorage.getItem('application_form_id')
      ) || null;

      return current_application_form_id
        ? `default:${current_application_form_id}`
        : 'default:unscoped';
    },

    get_application_forms_cache_value(cache_key) {
      return Reflect.get(this.application_forms_cache, cache_key) || null;
    },

    set_application_forms_cache_value(cache_key, value) {
      Reflect.set(this.application_forms_cache, cache_key, value);
    },

    get_application_forms_request_value(cache_key) {
      return Reflect.get(this.application_forms_request, cache_key) || null;
    },

    set_application_forms_request_value(cache_key, value) {
      Reflect.set(this.application_forms_request, cache_key, value);
    },

    normalize_application_forms_response(response_body) {
      return Array.isArray(response_body)
        ? response_body
        : (Array.isArray(response_body?.data)
          ? response_body.data
          : (response_body?.data ? [response_body.data] : []));
    },

    async fetch_application_forms({ profile = false, force = false } = {}) {
      const cache_key = this.get_application_forms_cache_key({ profile });
      const cached = this.get_application_forms_cache_value(cache_key);
      if (!force && cached) {
        return cached;
      }

      const inflight_request = this.get_application_forms_request_value(cache_key);
      if (!force && inflight_request) {
        return inflight_request;
      }

      const params = profile ? { profile: 1 } : {};
      const current_application_form_id = Number(this.application_form_id || sessionStorage.getItem('application_form_id')) || null;
      if (!profile && current_application_form_id) {
        params.application_form_id = current_application_form_id;
      }

      const request = axios.get(GET_APPLICATION_FORMS, {
        headers: this.headers,
        params: Object.keys(params).length ? params : undefined,
      }).then((response) => {
        const response_body = response.data;
        const payload = {
          response_body,
          response_forms: this.normalize_application_forms_response(response_body),
        };
        this.set_application_forms_cache_value(cache_key, payload);
        return payload;
      }).finally(() => {
        this.set_application_forms_request_value(cache_key, null);
      });

      this.set_application_forms_request_value(cache_key, request);
      return request;
    },

    async fetch_profile_status() {
      if (this.profile_status_cache) {
        return this.profile_status_cache;
      }

      if (this.profile_status_request) {
        return this.profile_status_request;
      }

      try {
        this.profile_status_request = axios.get(GET_PROFILE_STATUS_URL, {
          headers: this.headers,
        }).then((response) => {
          this.profile_status_cache = response?.data?.data || {};
          return this.profile_status_cache;
        });

        return await this.profile_status_request;
      } catch (error) {
        this.profile_status_cache = {};
      } finally {
        this.profile_status_request = null;
      }

      return this.profile_status_cache;
    },

    async has_preview_for_application_form(application_form_id, { force = false } = {}) {
      if (!application_form_id) return false;

      const cache_key = String(application_form_id);
      if (!force && this.preview_capability_cache.has(cache_key)) {
        return Boolean(this.preview_capability_cache.get(cache_key));
      }

      if (!force && this.preview_capability_request.has(cache_key)) {
        return this.preview_capability_request.get(cache_key);
      }

      try {
        const request = axios.post(
          PREVIEW_ONBOARDING_URL,
          { application_form_id },
          { headers: this.headers }
        ).then((response) => {
          const has_preview = Boolean(
            response?.data?.status === 'success' &&
            (response?.data?.preview_url || response?.data?.embed_src)
          );
          this.preview_capability_cache.set(cache_key, has_preview);
          return has_preview;
        }).finally(() => {
          this.preview_capability_request.delete(cache_key);
        });

        this.preview_capability_request.set(cache_key, request);
        return await request;
      } catch (error) {
        this.preview_capability_cache.set(cache_key, false);
        return false;
      }
    },

    async prepare_gate_actions(forms = null) {
      this.gate_can_preview = false;
      this.gate_entity_application_form_id = null;

      try {
        const response_forms = Array.isArray(forms) && forms.length
          ? forms
          : (await this.fetch_application_forms()).response_forms;

        const entity_payload = (response_forms || []).find((item) =>
          this.is_entity_form_type(item?.form?.form_type?.form_type)
        );

        const entity_application_form_id = entity_payload?.application_form_id || entity_payload?.id || null;
        this.gate_entity_application_form_id = entity_application_form_id;
      } catch (error) {
        this.gate_can_preview = false;
        this.gate_entity_application_form_id = null;
      }
    },

    async preview_complete_application() {
      const did_proceed = await this.proceed_to_complete_application();
      if (!did_proceed) {
        return;
      }

      if (this.preview_blocked_by_required_confirmation) {
        this.show_info('You will not be able to preview or submit the application if the required option is not selected.');
        return;
      }

      if (!this.can_preview_submission) {
        this.show_info('No submission template is assigned to this application form.');
        return;
      }

      await this.generate_form_preview();
    },

    async maybe_show_profile_choice_gate(forms = null) {
      if (this.expect_entity_form_after_profile || this.is_profile_update_mode) {
        return;
      }

      if (this.suppress_profile_gate_once) {
        this.suppress_profile_gate_once = false;
        return;
      }

      if (this.show_profile_completion_gate && this.profile_gate_mode === 'choice') {
        return;
      }

      if (this.current_form_type_name !== 'entity form') {
        return;
      }

      const profile_status = await this.fetch_profile_status();
      const is_profile_completed = Boolean(profile_status?.profile_completed);
      if (!is_profile_completed) {
        return;
      }

      this.show_profile_completion_gate = true;
      this.profile_gate_mode = 'choice';
      this.profile_completion_gate_message =
        'Your profile is already completed. You can review and update it before continuing with this job application, or proceed directly.';
      await this.prepare_gate_actions(forms);
    },

    select_application_form_payload(forms, { is_profile_route = false } = {}) {
      const normalized_forms = Array.isArray(forms) ? forms.filter(Boolean) : [];
      if (!normalized_forms.length) return null;

      if (is_profile_route) {
        return normalized_forms.find((item) =>
          this.is_profile_form_type(item?.form?.form_type?.form_type)
        ) || normalized_forms[0];
      }

      if (this.expect_entity_form_after_profile) {
        return normalized_forms.find((item) =>
          this.is_entity_form_type(item?.form?.form_type?.form_type)
        ) || null;
      }

      return normalized_forms[0];
    },

    async goToPrevSection() {
      if (this.current_section_index <= 0) {
        return;
      }

      const save_ok = await this.save_section({ skip_validation: true, silent: true });
      if (!save_ok) {
        return;
      }

      this.current_section_index--;
      this.$nextTick(() => {
        this.scroll_to_section_centered(this.current_section_index);
      });
    },

    async goToNextSection() {
      const total_sections = this.safe_form_config.sections?.length || 0;
      if (this.current_section_index >= total_sections - 1) {
        return;
      }

      const save_ok = await this.save_section({ silent: true });
      if (!save_ok) {
        return;
      }

      this.current_section_index++;
      this.$nextTick(() => {
        this.scroll_to_section_centered(this.current_section_index);
      });
    },

    goToSection(sectionIndex) {
      if (
        sectionIndex < 0 ||
        sectionIndex >= (this.safe_form_config.sections?.length || 0)
      ) {
        return;
      }

      if (this.show_form_preview) {
        this.show_form_preview = false;
      }

      this.current_section_index = sectionIndex;
      this.$nextTick(() => {
        this.scroll_to_section_centered(sectionIndex);
      });
    },

    async fetch_user_identity_defaults({ force = false } = {}) {
      if (!force && this.user_identity_defaults_loaded) {
        return this.user_identity_defaults;
      }

      if (!force && this.user_identity_defaults_request) {
        return this.user_identity_defaults_request;
      }

      try {
        this.user_identity_defaults_request = axios.get(GET_USER_PROFILE_DETAILS_URL, {
          headers: this.headers,
        }).then((response) => {
          const user_data = response?.data?.data || {};
          this.user_identity_defaults = {
            first_name: user_data.first_name || '',
            last_name: user_data.last_name || '',
            full_name: user_data.full_name || `${user_data.first_name || ''} ${user_data.last_name || ''}`.trim(),
            email: user_data.email || '',
            phone_number: user_data.phone_number || '',
          };
          this.user_identity_defaults_loaded = true;
          return this.user_identity_defaults;
        });

        return await this.user_identity_defaults_request;
      } catch (error) {
        this.user_identity_defaults = {};
        this.user_identity_defaults_loaded = true;
      } finally {
        this.user_identity_defaults_request = null;
      }

      return this.user_identity_defaults;
    },

    get_identity_fallback_for_question(question_text) {
      const label = String(question_text || '').toLowerCase();
      if (/(full\s*names?|names?\s*\(as\s*per\s*id\)|names?\s+as\s+per\s+id)/.test(label)) {
        return this.user_identity_defaults.first_name || '';
      }
      if (/\binitials?\b/.test(label)) {
        return String(this.user_identity_defaults.first_name || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean)
          .map((name) => name.charAt(0).toUpperCase())
          .join('');
      }
      if (/(first\s*name|given\s*name|name\s*of\s*applicant)/.test(label)) {
        return this.user_identity_defaults.first_name || '';
      }
      if (/(last\s*name|surname|family\s*name)/.test(label)) {
        return this.user_identity_defaults.last_name || '';
      }
      if (/(email|e-mail)/.test(label)) {
        return this.user_identity_defaults.email || '';
      }
      if (/(phone|mobile|contact\s*number|telephone|cell\s*number)/.test(label)) {
        return this.user_identity_defaults.phone_number || '';
      }
      return '';
    },

    is_prepopulated_readonly_question(question_text) {
      const normalized_question = String(question_text || '').trim().toLowerCase();
      if (!normalized_question) return false;

      const locked_questions = [
        this.department_question,
        this.job_position_question,
        this.reference_number_question,
      ]
        .filter(Boolean)
        .map((item) => String(item).trim().toLowerCase());

      return locked_questions.includes(normalized_question);
    },

    is_locked_advertised_post_field(_section, _field_index, field) {
      if (!field) return false;
      return Boolean(
        field.is_readonly_prepopulated ||
        this.is_prepopulated_readonly_question(field.label || field.placeholder)
      );
    },

    locked_advertised_post_style(section, field_index, field) {
      if (!this.is_locked_advertised_post_field(section, field_index, field)) return null;

      return {
        backgroundColor: '#f8f9fa',
        cursor: 'not-allowed',
      };
    },

    get_all_form_fields() {
      const fields = [];

      const collect_fields = (nodes = []) => {
        (nodes || []).forEach((node) => {
          if (!node) return;
          fields.push(node);
          if (Array.isArray(node.dependent_questions) && node.dependent_questions.length) {
            collect_fields(node.dependent_questions);
          }
        });
      };

      (this.safe_form_config?.sections || []).forEach((section) => {
        collect_fields(section?.fields || []);
      });

      return fields;
    },

    find_field_by_label_match(patterns = []) {
      const compiled_patterns = Array.isArray(patterns)
        ? patterns.filter((pattern) => pattern instanceof RegExp)
        : [];

      if (!compiled_patterns.length) return null;

      return this.get_all_form_fields().find((field) => {
        const label = String(field?.label || field?.question_text || '').trim();
        return label && compiled_patterns.some((pattern) => pattern.test(label));
      }) || null;
    },

    resolve_autofill_value_for_field(field, raw_value) {
      if (!field) return raw_value;

      if (Array.isArray(field.options) && field.options.length) {
        const normalized_raw_value = String(raw_value || '').trim().toLowerCase();
        const matching_option = field.options.find((option) => {
          const option_text = String(option?.text || '').trim().toLowerCase();
          const option_value = String(option?.value || '').trim().toLowerCase();
          return option_text === normalized_raw_value || option_value === normalized_raw_value;
        });

        if (matching_option) {
          return matching_option.value || matching_option.text || raw_value;
        }
      }

      return raw_value;
    },

    set_autofill_field_value(field, raw_value) {
      if (!field?.model || raw_value === null || raw_value === undefined || raw_value === '') return;

      const value = this.resolve_autofill_value_for_field(field, raw_value);
      Reflect.set(this.safe_form_data, field.model, value);
      this.clear_validation_error(field.model);

      if (typeof this.update_dependent_questions_visibility === 'function') {
        this.update_dependent_questions_visibility(field, value);
      }
    },

    apply_sa_id_derived_details(validation_details) {
      if (!validation_details) return;

      const date_of_birth = validation_details.date_of_birth || null;
      const gender = validation_details.gender || null;
      const citizenship = validation_details.citizenship || null;

      this.DOB = date_of_birth;
      this.gender = gender;
      this.citizenship = citizenship;

      const dob_field = this.find_field_by_label_match([
        /\bdate\s*of\s*birth\b/i,
        /\bdob\b/i,
        /\bbirth\s*date\b/i,
      ]);
      const gender_field = this.find_field_by_label_match([
        /\bgender\b/i,
        /\bsex\b/i,
      ]);
      const citizenship_field = this.find_field_by_label_match([
        /\bcitizenship\b/i,
        /\bnationality\b/i,
        /\bcitizen(ship)?\s*status\b/i,
      ]);

      this.set_autofill_field_value(dob_field, date_of_birth);
      this.set_autofill_field_value(gender_field, gender);
      this.set_autofill_field_value(citizenship_field, citizenship);
    },

    async detect_preview_capability() {
      // Avoid calling the preview API during form load. The preview endpoint depends on
      // DocuSeal availability and should only be hit when the user explicitly requests it.
      this.can_preview_submission = false;
    },

    // Add this new method for clean exit
    exit_preview() {
      this.show_form_preview = false;
      this.current_section_index = this.safe_form_config.sections.length - 1;
      this.form_preview_url = null; // Clear the preview URL when exiting
      this.is_preview_loading = false;
    },

    get_preview_application_form_id() {
      return Number(
        this.gate_entity_application_form_id
        || this.application_form_id
        || sessionStorage.getItem('application_form_id')
        || 0
      ) || null;
    },

    async validate_preview_request() {
      if (this.preview_blocked_by_required_confirmation) {
        this.show_info('You will not be able to preview or submit the application if you do not confirm.');
        return false;
      }

      const save_ok = await this.save_section({ silent: true });
      if (!save_ok) {
        return false;
      }

      const preview_application_form_id = this.get_preview_application_form_id();
      if (!preview_application_form_id) {
        this.show_error('Preview failed because the application form ID is missing.');
        return false;
      }

      return true;
    },

    prepare_preview_state() {
      this.submit_attempted = true;
      this.is_preview_loading = true;
      this.show_form_preview = true;
      this.form_preview_url = null;
    },

    build_preview_request_payload() {
      return {
        application_form_id: this.get_preview_application_form_id(),
      };
    },

    async show_generated_preview(preview_src) {
      await this.$nextTick();
      this.form_preview_url = preview_src;
      this.can_preview_submission = true;

      this.$nextTick(() => {
        const carousel = this.$refs.carousel;
        const previewElement = carousel && typeof carousel.querySelector === 'function'
          ? carousel.querySelector(`.form-wrapper[data-index="${this.safe_form_config.sections.length}"]`)
          : null;
        if (previewElement) {
          previewElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },

    async handle_preview_response(preview_payload) {
      const preview_src = preview_payload.embed_src || preview_payload.preview_url || null;
      const submitters = Array.isArray(preview_payload.submitters) ? preview_payload.submitters : [];
      const first_submitter = submitters[0] || {};

      this.docuseal_submission_id =
        first_submitter.submission_id || preview_payload.submission_id || null;

      if (
        preview_payload.status === 'pending'
        || preview_payload.status === 'queued'
        || preview_payload.message?.toLowerCase?.().includes('pending')
      ) {
        this.show_info(
          preview_payload.message || 'Preview generation is still processing. Please wait and try again.'
        );
        this.exit_preview();
        return;
      }

      if (preview_payload.status === 'success' && preview_src) {
        await this.show_generated_preview(preview_src);
        return;
      }

      this.show_error(
        preview_payload.message
        || 'Preview was generated without a display URL. Please check the template configuration.'
      );
      this.exit_preview();
    },

    handle_preview_error(err) {
      const error_message =
        err?.response?.data?.message
        || err?.response?.data?.details
        || err?.message
        || 'Error generating preview';
      this.show_error(error_message);
      this.exit_preview();
    },

    async generate_form_preview() {
      try {
        const can_preview = await this.validate_preview_request();
        if (!can_preview) {
          return;
        }

        this.prepare_preview_state();
        const request_payload = this.build_preview_request_payload();

        const res = await axios.post(
          PREVIEW_ONBOARDING_URL,
          request_payload,
          { headers: this.headers }
        );

        await this.handle_preview_response(res?.data || {});
      } catch (err) {
        this.handle_preview_error(err);
      } finally {
        this.is_preview_loading = false;
      }
    },
    on_update_field({ key, value }) {
      Reflect.set(this.safe_form_data, key, value);
    },

    get_current_section() {
      return Reflect.get(this.safe_form_config?.sections || [], this.current_section_index) || null;
    },

    get_empty_value_for_field(field) {
      const field_type = String(field?.type || '').toLowerCase();

      if (field_type === 'multi_select' || field_type === 'checkboxes') {
        return [];
      }

      if (field_type === 'file' || field_type === 'pdf_file' || field_type === 'facial_verification') {
        return null;
      }

      return '';
    },

    clear_field_runtime_state(field) {
      if (!field?.model) return;

      Reflect.set(this.validation_errors, field.model, null);
      Reflect.set(this.file_validation_error, field.model, null);
      Reflect.set(this.sa_id_validation_errors, field.model, false);
      Reflect.set(this.sa_id_validation_messages, field.model, null);
      Reflect.set(this.sa_id_validation_details, field.model, null);
      Reflect.set(this.select_field_touched, field.model, false);

      if (field.other_model) {
        Reflect.set(this.safe_form_data, field.other_model, '');
        Reflect.set(this.validation_errors, field.other_model, null);
      }

      const comment_key = `${field.model}_file_comment`;
      if (Reflect.has(this.safe_form_data, comment_key)) {
        Reflect.set(this.safe_form_data, comment_key, '');
      }

      if (String(field.type || '').toLowerCase() === 'phone') {
        Reflect.set(this.phone_country_codes, field.model, '+27');
        Reflect.set(this.phone_raw_digits, field.model, '');
      }
    },

    clear_field_and_dependents(field) {
      if (!field) return;

      if (!field.is_readonly_prepopulated && field.model) {
        Reflect.set(this.safe_form_data, field.model, this.get_empty_value_for_field(field));
        this.clear_field_runtime_state(field);
      }

      (field.dependent_questions || []).forEach((child) => {
        this.clear_field_and_dependents(child);
        child.is_visible = false;
      });

      if (typeof this.update_dependent_questions_visibility === 'function') {
        this.update_dependent_questions_visibility(
          field,
          Reflect.get(this.safe_form_data, field.model)
        );
      }
    },

    clear_fields_collection(fields = []) {
      (fields || []).forEach((field) => this.clear_field_and_dependents(field));
    },

    clear_work_experience_section(section_id) {
      const all_blocks = Reflect.get(this._all_we_blocks_by_section || {}, section_id) || [];
      const fallback_blocks = Reflect.get(this.work_experience_blocks, section_id) || [];
      const blocks = all_blocks.length ? all_blocks : fallback_blocks;

      blocks.forEach((block, index) => {
        (block.fields || []).forEach((field) => {
          Reflect.set(this.safe_form_data, field.model, this.get_empty_value_for_field(field));
          this.clear_field_runtime_state(field);
        });
        block.currently_work_here = false;
        block.label = `Experience ${index + 1}`;
      });

      if (blocks.length > 0) {
        Reflect.set(this.work_experience_blocks, section_id, [blocks[0]]);
      }
    },

    clear_structured_blocks_section(section_id, type) {
      const all_map = type === 'language'
        ? (this._all_language_blocks_by_section || {})
        : (type === 'education'
          ? (this._all_education_blocks_by_section || {})
          : (this._all_reference_blocks_by_section || {}));

      const visible_map = type === 'language'
        ? this.language_blocks
        : (type === 'education' ? this.education_blocks : this.reference_blocks);

      const label_prefix = type === 'language' ? 'Language' : (type === 'education' ? 'Qualification' : 'Reference');
      const all_blocks = Reflect.get(all_map, section_id) || [];
      const fallback_blocks = Reflect.get(visible_map, section_id) || [];
      const blocks = all_blocks.length ? all_blocks : fallback_blocks;

      blocks.forEach((block, index) => {
        (block.fields || []).forEach((field) => {
          Reflect.set(this.safe_form_data, field.model, this.get_empty_value_for_field(field));
          this.clear_field_runtime_state(field);
        });
        block.label = `${label_prefix} ${index + 1}`;
      });

      if (blocks.length > 0) {
        Reflect.set(visible_map, section_id, [blocks[0]]);
      }
    },

    clear_current_section_answers(section = null) {
      const current_section = section || this.get_current_section();
      if (!current_section) return;

      this.clear_fields_collection(current_section.fields || []);
      this.clear_work_experience_section(current_section.id);
      this.clear_structured_blocks_section(current_section.id, 'language');
      this.clear_structured_blocks_section(current_section.id, 'education');
      this.clear_structured_blocks_section(current_section.id, 'reference');

      this.submit_attempted = false;
    },

    async confirm_clear_current_section(section = null) {
      const current_section = section || this.get_current_section();
      if (!current_section) return;

      const result = await Swal.fire({
        title: 'Clear Current Section',
        text: 'Are you sure you want to clear all field answers?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      });

      if (!result.isConfirmed) return;

      this.clear_current_section_answers(current_section);
    },

    is_required_option_missing(field, option) {
      if (!field || !option || !option.is_mandatory) return false;

      const touched = Reflect.get(this.select_field_touched, field.model);
      if (!touched) return false;

      const selected_value = Reflect.get(this.safe_form_data, field.model);
      const option_value = String(option.value || option.text || '').trim();

      if (field.type === 'single_select' || field.type === 'radio') {
        const selected = String(selected_value || '').trim();
        if (!selected) return false;
        return selected !== option_value;
      }

      if (field.type === 'multi_select' || field.type === 'checkboxes') {
        const selected_values = Array.isArray(selected_value)
          ? selected_value.map((item) => String(item).trim())
          : [];
        return !selected_values.includes(option_value);
      }

      return false;
    },

    update_select_validation_error(field) {
      if (!field || !field.model) return;

      const current_value = Reflect.get(this.safe_form_data, field.model);
      const missing_options = this.get_missing_required_options(field, current_value);

      if (missing_options.length > 0) {
        const required_option_message = this.get_required_option_error_message(field, missing_options);
        if (required_option_message) {
          Reflect.set(
            this.validation_errors,
            field.model,
            required_option_message
          );
        } else if (Reflect.has(this.validation_errors, field.model)) {
          Reflect.deleteProperty(this.validation_errors, field.model);
        }
        return;
      }

      if (Reflect.has(this.validation_errors, field.model)) {
        Reflect.deleteProperty(this.validation_errors, field.model);
      }
    },

    handle_select_change(field) {
      if (!field || !field.model) return;

      Reflect.set(this.select_field_touched, field.model, true);
      this.update_dependent_questions_visibility(field, Reflect.get(this.safe_form_data, field.model));
      this.update_select_validation_error(field);

      const current_value = Reflect.get(this.safe_form_data, field.model);
      const missing_options = this.get_missing_required_options(field, current_value);
      const has_required_option_unmet = missing_options.length > 0;
      const has_selected_value = this.has_required_value(current_value);

      if (has_required_option_unmet && has_selected_value) {
        this.show_confirm(
          'Required Option Not Selected',
          'You will not be able to preview or submit the application if the required option is not selected. Would you like us to log you out?',
          () => this.logout(),
          null
        );
      }
    },

    handleNumberInput(event, field) {
      const value = event.target.value.replace(/\D/g, '')
      Reflect.set(this.safe_form_data, field.model, value)
      event.target.value = value
    },
    // Debounced scroll handler using rAF
    _onCarouselScroll() {
      if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = requestAnimationFrame(() => {
        this.handle_scroll();
        this._scrollRaf = null;
      });
    },

    // Touchend fallback: many mobile browsers complete the swipe after touchend
    _onCarouselTouchEnd() {
      if (this._touchTimeout) clearTimeout(this._touchTimeout);
      // short delay so the browser finishes inertia scroll
      this._touchTimeout = setTimeout(() => {
        this.handle_scroll();
        this._touchTimeout = null;
      }, 80);
    },

    _onWindowResize() {
      // re-evaluate visible section on resize/orientation change
      if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(() => {
        this.handle_scroll();
        this._resizeTimeout = null;
      }, 120);
    },

    async save_progress_to_server() {
      await axios.post(SAVE_FORM_PROGRESS, {
        application_form_id: this.application_form_id,
        current_section_index: this.current_section_index
      }, {
        headers: this.headers
      });
    },

    async load_progress_from_server() {
      try {
        const response = await axios.get(GET_FORM_PROGRESS, {
          headers: this.headers,
          params: {
            application_form_id: this.application_form_id
          }
        });

        if (response.data.status === 'success' && response.data.current_section_index !== undefined) {
          const savedSectionIndex = response.data.current_section_index;

          if (savedSectionIndex >= 0 && savedSectionIndex < this.safe_form_config.sections.length) {
            this.current_section_index = savedSectionIndex;
            await this.$nextTick();
            this.scroll_to_section(savedSectionIndex);
          }
        }
      } catch (error) {
        // Silently ignore errors - this is expected when user has no entity profile yet
      }
    },

    async clear_progress() {
      await axios.delete(CLEAR_FORM_PROGRESS, {
        headers: this.headers,
        data: {
          application_form_id: this.application_form_id
        }
      });
    },

    get_file_action_text(fileData) {
      return this.is_word_document(fileData) ? 'Download' : 'Preview';
    },

    guess_preview_type(filename = '', mime = '') {
      const name = String(filename || '').toLowerCase();
      const m = String(mime || '').toLowerCase();
      // Word documents
      if (m.includes('word') || /\.(doc|docx)$/.test(name)) return 'word';
      // Images
      if (m.startsWith('image/') || /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(name)) return 'image';
      // PDF
      if (m === 'application/pdf' || /\.pdf$/.test(name)) return 'pdf';
      // Videos
      if (m.startsWith('video/') || /\.(mp4|webm|ogg|mov)$/.test(name)) return 'video';
      return 'other';
    },

    is_word_document(fileData) {
      if (!fileData) return false;
      const filename = fileData.file_name || '';
      const file = fileData.file;
      if (file instanceof File) {
        return this.guess_preview_type(file.name, file.type) === 'word';
      }
      return /\.(doc|docx)$/i.test(filename);
    },

    approve(section_id) {
      const data = {
        form_section_id: section_id,
        is_verified: true,
        application_form_id: parseInt(this.application_form_id, 10),
        verification_comment: "",
      };
      axios.post(VERIFY_SECTION_URL, data, {
        headers: this.headers
      })
        .then(response => {
          const response_data = response.data;
          if (response_data.status === 'success') {
            this.get_form_to_preview({ force: true });
            this.show_success("Section verified successfully.")
          } else {
            this.show_error('Error during the form submit');
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    toggle_requested_field(event, field) {
      if (event.target.checked) {
        this.selected_request_fields.push({
          form_section_id: this.active_section,
          form_section_name: this.active_section_name,
          requested_field_id: field.section_question_id,
          requested_field_text: field.question_text
        });
      } else {
        this.selected_request_fields = this.selected_request_fields.filter(
          selected => selected.requested_field_id !== field.section_question_id
        );
      }
    },

    async request_information() {
      if (!this.validate_request_information_inputs()) return;
      const application_form_id = parseInt(this.safe_form_config.formId, 10);
      const message = this.request_info_note;
      const requested_fields = this.selected_request_fields;
      const data = {
        application_form_id: application_form_id,
        message: message,
        requested_fields: requested_fields,
      };

      const response = await axios.post(REQUEST_INFO_URL, data, {
        headers: this.headers
      });

      if (response.data.status === 'success') {
        this.show_success("Information successfully requested");
      } else {
        this.show_error('Error during the form submit');
      }
    },

    validate_request_information_inputs() {
      if (!validate_non_empty_string(this.request_info_note)) {
        this.show_error('Request information note must not be null');
        return false;
      }
      if (!validate_non_sub_zero_number(parseInt(this.application_form_id, 10))) {
        this.show_error('Profile role form id must not be null');
        return false;
      }
      return true;
    },

    _init_dependent_form_data(dep_list = []) {
      (dep_list || []).filter(Boolean).forEach((dependent_question) => {
        Reflect.set(
          this.safe_form_data,
          dependent_question.model,
          dependent_question.type === "multi_select" ? (dependent_question.value || []) : (dependent_question.value || "")
        );

        if (dependent_question.type === "file") {
          const commentKey = dependent_question.model + "_file_comment";
          if (!Reflect.has(this.safe_form_data, commentKey)) {
            Reflect.set(this.safe_form_data, commentKey, "");
          }
        }

        if (dependent_question.dependent_questions?.length) {
          this._init_dependent_form_data(dependent_question.dependent_questions);
        }
      });
    },


    async get_form_to_preview({ force = false } = {}) {
      try {
        this.is_loading_form = true;

        const is_profile_route = this.$route?.path?.startsWith('/profile_view');
        const should_load_profile_form = is_profile_route || this.is_profile_update_mode;
        const should_load_identity_defaults = should_load_profile_form || this.$route?.path === '/entity_onboarding_forms';
        const identity_defaults_request = should_load_identity_defaults
          ? this.fetch_user_identity_defaults()
          : Promise.resolve(null);

        const application_forms_request = this.fetch_application_forms({
          profile: should_load_profile_form,
          force: force || this.$route?.path === '/entity_onboarding_forms',
        });

        const [{ response_body, response_forms }] = await Promise.all([
          application_forms_request,
          identity_defaults_request,
        ]);

        // If no forms are assigned, redirect to view_all_user_forms page silently
        if (!response_forms.length) {
          this.$router.push('/view_all_user_forms');
          return false;
        }

        const payload = this.select_application_form_payload(response_forms, {
          is_profile_route: should_load_profile_form,
        });

        if (!payload) {
          return false;
        }

        this.current_form_type_name = String(payload?.form?.form_type?.form_type || '').trim().toLowerCase();
        if (this.current_form_type_name === 'entity form') {
          this.is_profile_update_mode = false;
        }

        this.application_form_id = payload.application_form_id || payload.id;
        this.user_role = normalize_user_role(
          response_body?.logged_in_user_role || this.user_role || sessionStorage.getItem('user_role')
        );
        if (this.user_role) {
          sessionStorage.setItem('user_role', this.user_role);
        }
        this.job_position_name = payload.advert_title || '';
        this.reference_number = payload.advert_reference_number || '';
        this.apply_advert_dates_from_payload(payload);
        const advert_dates_request = this.hydrate_advert_dates_from_public_api().catch(() => null);

        if (this.is_job_application && this.is_current_advert_closed()) {
          sessionStorage.removeItem('entity_applying');
          this.$router.push({
            path: '/view_all_user_forms',
            query: { tab: 'jobs', tracker: 'all_jobs' },
          });
          return false;
        }

        const include_unassigned_sections_for_admin = this.is_system_admin_role(this.user_role);

        /* ---------------------------------------------------
        * Build lookup map once
        * --------------------------------------------------- */
        const all_questions_map = Object.create(null);
        const all_questions_meta = {
          byQuestionId: Object.create(null),
          byLabel: Object.create(null),
        };
        const normalize_question_lookup_key = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
        const index_question = (question, { overwrite = true } = {}) => {
          if (!question) return;

          [
            {
              store: all_questions_map,
              key: question.section_question_id ?? null,
            },
            {
              store: all_questions_meta.byQuestionId,
              key: question.id ?? question.dependant_question_id ?? question.question_id ?? null,
            },
            {
              store: all_questions_meta.byLabel,
              key: normalize_question_lookup_key(
                question.question_text || question.dependant_question_text || ''
              ),
            },
          ]
            .filter(({ key }) => key)
            .forEach(({ store, key }) => {
              if (overwrite || !Reflect.has(store, key)) {
                Reflect.set(store, key, question);
              }
            });
        };

        Reflect.set(all_questions_map, '__meta', all_questions_meta);

        // Recursively index ALL questions (including nested dependants) into the map
        // so build_dependent_question can resolve them at any depth.
        const _index_questions = (dependent_question_list) => {
          (dependent_question_list || []).forEach(dependent_question => {
            if (!dependent_question) return;

            index_question(
              {
                id: dependent_question.dependant_question_id ?? null,
                section_question_id: dependent_question.dependant_section_question_id ?? null,
                question_text: dependent_question.dependant_question_text,
                question_type: dependent_question.dependant_question_type || { question_type: 'short_text' },
                answer: dependent_question.answer ?? null,
                multi_select_choices: dependent_question.multi_select_choices || [],
                is_mandatory: dependent_question.is_mandatory,
              },
              { overwrite: false }
            );

            // Keep descending
            _index_questions(dependent_question.dependant_questions || []);
          });
        };

        payload.form.sections.forEach(section =>
          section.questions.forEach(question => {
            index_question(question);
            // Also index every nested dependant question from this top-level question
            _index_questions(question.dependant_questions || []);
          })
        );

        /* ---------------------------------------------------
        * Build form config
        * --------------------------------------------------- */
        this.safe_form_config = {
          submission_id: payload.application_form_id,
          form_title: payload.form_name,
          formId: payload.form_id,
          sections: payload.form.sections
            .filter(section =>
              include_unassigned_sections_for_admin
              || section.questions?.length
              || section.is_work_experience
              || section.is_language
              || section.is_education
              || section.is_reference
            )
            .map(section => {
              const section_questions = Array.isArray(section.questions) ? section.questions : [];
              // Auto-detect WE sections: if all non-dependent questions have [WE N] prefix
              const _we_prefix_re = /^\[WE\s+\d+\]/i;
              const non_dep_qs = section_questions.filter(q => !q.is_dependent);
              const is_we_by_labels = non_dep_qs.length > 0 && non_dep_qs.every(q => _we_prefix_re.test(q.question_text));
              const is_work_exp = section.is_work_experience || is_we_by_labels;
              const section_name = String(section.name || '').trim().toLowerCase();
              const is_language = Boolean(section.is_language) || section_name === 'languages';
              const is_education = Boolean(section.is_education) || section_name === 'education';
              const is_reference = Boolean(section.is_reference) || section_name === 'references';
              const main_title =
                section.main_section?.name ||
                section.main_section_name ||
                section.form_main_section?.name ||
                section.form_main_section_name ||
                section.parent_section?.name ||
                section.parent_section_name ||
                payload.form_main_section_name ||
                payload.main_section_name ||
                '';
              return {
                id: section.id,
                is_verified: section.is_verified,
                is_work_experience: is_work_exp,
                is_language,
                is_education,
                is_reference,
                main_title,
                title: section.name,
                fields: section_questions
                  .filter(q => !q.is_dependent)
                  .map(q => {
                    const option_map = this.build_option_map(q.multi_select_choices);
                    let value = this.deserialize_answer(
                      q.answer,
                      q.question_type.question_type,
                      option_map
                    );

                    if (
                      should_load_identity_defaults &&
                      ['short_text', 'email', 'number'].includes(q.question_type.question_type) &&
                      (value === '' || value === null || value === undefined)
                    ) {
                      value = this.get_identity_fallback_for_question(q.question_text);
                    }

                    return {
                      label: q.question_text,
                      model: `q_${q.section_question_id}`,
                      id: `q_${q.section_question_id}`,
                      section_question_id: q.section_question_id,
                      registration_source_mapping_id: q.registration_source_question?.id || null,
                      type: this.map_question_type(q.question_type.question_type),
                      required: q.is_mandatory,
                      required_options: (q.multi_select_choices || [])
                        .filter((choice) => choice.is_mandatory)
                        .map((choice) => choice.choice),
                      placeholder: q.question_text,
                      options: (q.multi_select_choices || []).map(c => ({
                        text: c.choice,
                        value: c.choice,
                        is_mandatory: Boolean(c.is_mandatory)
                      })),
                      value,
                      dependent_questions: (q.dependant_questions || [])
                        .map(dq => this.build_dependent_question(dq, all_questions_map))
                        .filter(Boolean),
                      is_readonly_prepopulated: this.is_prepopulated_readonly_question(q.question_text),

                      is_dependent: false
                    };
                  })
              };
            })
        };

        /* ---------------------------------------------------
        * Initialise form data with pre-filled values
        * --------------------------------------------------- */
        Object.keys(this.safe_form_data).forEach((key) => {
          Reflect.set(this.safe_form_data, key, undefined);
        });
        this.safe_form_config.sections.forEach(section =>
          section.fields.forEach(field => {
            let initialValue = field.value || '';

            // Custom overrides for specific fields
            if (field.label === JOB_POSITION_QUESTION) {
              initialValue = this.job_position_name;
            } else if (field.label === REFERENCE_NUMBER_QUESTION) {

              initialValue = payload.advert_reference_number || '';
            } else if (field.label === DEPARTMENT_QUESTION) {
              initialValue = this.department_name;
            }

            Reflect.set(
              this.safe_form_data,
              field.model,
              field.type === 'multi_select' ? (initialValue || []) : initialValue
            );

            this._init_dependent_form_data(field.dependent_questions || []);
          })
        );

        // Ensure mapped/preloaded phone values are displayed in normalized format immediately.
        this.normalize_prefilled_phone_fields();

        // Initialise work experience blocks for sections flagged as work experience
        this._init_work_experience_sections();
        this._init_structured_card_sections();

        await this.$nextTick();
        this.setup_dependent_question_listeners();
        this.normalize_prefilled_phone_fields();
        this.detect_preview_capability();
        this.is_loading_form = false;

        Promise.allSettled([
          this.load_progress_from_server(),
          this.maybe_show_profile_choice_gate(response_forms),
          advert_dates_request,
        ]).then(() => {
          this.normalize_prefilled_phone_fields();
        });
        return true;

      } catch (error) {
        this.show_error("Error loading form");
        return false;
      } finally {
        if (this.safe_form_config?.sections?.length === 0) {
          this.is_loading_form = false;
        }
      }
    },

    async save_section({ skip_validation = false, silent = false } = {}) {
      if (this.is_submitting) return;
      this.submit_attempted = !skip_validation;
      this.is_submitting = true;
      const config = this.safe_form_config;
      const form_data = new FormData();
      const answers = [];
      const file_uploads = [];
      const current_section = Reflect.get(config.sections, this.current_section_index);

      if (!skip_validation) {
        const errors = {
          ...this.validate_required_fields(current_section),
          ...this.validate_structured_section_required(current_section),
        };
        this.validation_errors = errors;
        if (Object.keys(errors).length > 0) {
          await this.focus_first_error(errors);
          this.is_submitting = false;
          return false;
        }
      }

      // Collect answers — use work experience path if applicable
      const has_we_blocks = !!(this.work_experience_blocks[current_section.id]
        && this.work_experience_blocks[current_section.id].length);

      if (current_section.is_work_experience || has_we_blocks) {
        const we_answers = this._collect_work_experience_answers(current_section);
        answers.push(...we_answers);
        form_data.append(
          "work_experience_data",
          JSON.stringify(this._collect_work_experience_data(current_section))
        );
        this._collect_answers_recursive(current_section.fields, answers, file_uploads);
      } else {
        this._collect_answers_recursive(current_section.fields, answers, file_uploads);
      }

      const structured_answers = this._collect_structured_section_answers(current_section);
      answers.push(...structured_answers);

      file_uploads.forEach(fu => {
        if (fu && fu.id && fu.file) {
          const key = `file_${String(fu.id)}`;
          form_data.append(key, fu.file);
        }
      });

      form_data.append("answers", JSON.stringify(answers));
      form_data.append("application_form_id", this.application_form_id);
      form_data.append("is_final_submission", false);
      form_data.append("current_section_index", this.current_section_index.toString());

      try {
        const res = await axios.post(
          SUBMIT_APPLICATION_FORMS_ANSWERS,
          form_data, { headers: { ...this.headers, "Content-Type": "multipart/form-data" } }
        );

        if (res.data && res.data.status === "success") {
          if (!silent) {
            this.show_success("Section saved successfully");
          }

          if (!this.completed_sections.includes(this.current_section_index)) {
            this.completed_sections.push(this.current_section_index);
          }

          await this.save_progress_to_server();

          return true; // ADD THIS
        } else {
          const msg = (res.data && res.data.message) || "Section submission failed";
          this.show_alert(msg);
          return false; // ADD THIS
        }
      } catch (error) {
        this.show_alert(error.response?.data?.message || error.message || "Error submitting section");
      } finally {
        this.is_submitting = false;
      }
    },


    _collect_answers_recursive(nodes = [], answers = [], file_uploads = [], seen = new Set()) {
      nodes.forEach((node) => {
        if (!node) return;

        // skip hidden dependents
        if (node.is_dependent && !node.is_visible) return;

        // prevent duplicates + cycles
        const id = node.section_question_id;
        if (id && seen.has(id)) return;
        if (id) seen.add(id);

        // collect answer for this node
        this.process_field(node, answers, file_uploads);

        // recurse into children
        if (Array.isArray(node.dependent_questions) && node.dependent_questions.length) {
          this._collect_answers_recursive(node.dependent_questions, answers, file_uploads, seen);
        }
      });
    },

    preview_template() {
      const request_payload = {};

      axios.post(PREVIEW_DOCUSEAL_URL, request_payload, { headers: this.headers })
        .then(response => {
          const payload = response.data;

          if (payload.status !== "success") {
            this.show_error(payload.message || "Failed to generate preview");
            return;
          }

          this.preview_url = payload.embed_src;
        })
        .catch(error => {
          const error_message = error.response?.data?.message || error.message;
          this.show_error(error_message);
        })
        .finally(() => {
          this.is_preview_loading = false;
        });
    },

    async save_and_logout() {
      if (this.is_submitting) return;

      const success = await this.save_section({ skip_validation: true });

      if (success) {
        this.logout();
      } else {
        this.show_alert("This advert is closed and submission is no longer possible.");
      }
    },

    async save_and_proceed_later() {
      if (this.is_submitting) return;

      const success = await this.save_section({ skip_validation: true });

      if (success) {
        this.show_success('Progress saved. You can continue later.');
      } else {
        this.show_alert('This advert is closed and submission is no longer possible.');
      }
    },

    // Make sure submit_answers also exits preview
    async submit_answers() {
      if (this.is_submitting) return;

      if (this.preview_blocked_by_required_confirmation) {
        this.show_info('You will not be able to preview or submit the application if the required option is not selected.');
        return;
      }

      let loader;

      try {
        loader = await this.show_loader("Submitting form...");

        // Exit preview mode before submitting
        this.show_form_preview = false;

        // Validate all sections
        this.submit_attempted = true;
        let errors = {};
        this.safe_form_config.sections.forEach(section => {
          errors = {
            ...errors,
            ...this.validate_required_fields(section),
            ...this.validate_structured_section_required(section),
          };
        });
        this.validation_errors = errors;

        if (Object.keys(errors).length > 0) {
          await this.focus_first_error(errors);
          this.is_submitting = false;
          this.show_info("Some mandatory fields were not filled in");
          return;
        }

        this.is_submitting = true;

        const config = this.safe_form_config;
        const form_data = new FormData();
        const answers = [];
        const file_uploads = [];
        const work_experience_data = {};

        config.sections.forEach(section => {
          const has_we = !!(this.work_experience_blocks[section.id]
            && this.work_experience_blocks[section.id].length);
          if ((section.is_work_experience || has_we) && this.work_experience_blocks[section.id]) {
            const we_answers = this._collect_work_experience_answers(section);
            answers.push(...we_answers);
            Object.assign(work_experience_data, this._collect_work_experience_data(section));
            this._collect_answers_recursive(section.fields, answers, file_uploads);
          } else {
            this._collect_answers_recursive(section.fields, answers, file_uploads);
          }

          const structured_answers = this._collect_structured_section_answers(section);
          answers.push(...structured_answers);
        });

        file_uploads.forEach(fu => form_data.append(`file_${fu.id}`, fu.file));
        form_data.append('answers', JSON.stringify(answers));
        form_data.append('application_form_id', config.submission_id);
        if (Object.keys(work_experience_data).length) {
          form_data.append('work_experience_data', JSON.stringify(work_experience_data));
        }
        if (this.docuseal_submission_id) {
          form_data.append('docuseal_submission_id', this.docuseal_submission_id);
        }
        form_data.append("is_final_submission", true);
        form_data.append('current_section_index', (config.sections.length - 1).toString());

        const res = await axios.post(
          SUBMIT_APPLICATION_FORMS_ANSWERS,
          form_data,
          {
            headers: {
              ...this.headers,
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (res.data.status !== 'success') {
          this.show_alert(res.data.message || "Form submission failed");
        } else {
          const is_profile_form = this.current_form_type_name === 'profile form';

          if (!is_profile_form) {
            this.show_success('Form submitted successfully');
          }
          await axios.post(SAVE_FORM_PROGRESS, {
            application_form_id: this.application_form_id,
            current_section_index: config.sections.length - 1,
            mark_completed: true
          }, {
            headers: this.headers
          });

          if (is_profile_form) {
            // Sync profile answers to entity form if one exists
            if (this.is_job_application) {
              try {
                await axios.post(SYNC_PROFILE_ANSWERS_TO_ENTITY_FORM, {
                  profile_application_form_id: this.application_form_id,
                }, { headers: this.headers });
              } catch (_) { /* best-effort sync */ }

              sessionStorage.removeItem('entity_applying');
              this.show_success('Application submitted successfully');
              this.clear_inline_form_notice();
              this.$router.push('/view_all_user_forms');
              return;
            }
            this.show_success('Profile submitted successfully');
            this.clear_inline_form_notice();
            this.$router.push('/view_all_user_forms');
            return;
          }

          sessionStorage.removeItem('entity_applying');
          this.clear_inline_form_notice();
          this.$router.push('/view_all_user_forms');
        }

      } catch (error) {
        this.show_alert(error.response?.data?.message || error.message || "Error submitting section");
      } finally {
        this.is_submitting = false;
        if (loader) await this.close_loader(loader);
      }
    },

    validate_sa_id_on_input(field) {
      const value = Reflect.get(this.safe_form_data, field.model);

      // Format input to only allow digits
      if (value && !/^\d*$/.test(value)) {
        Reflect.set(this.safe_form_data, field.model, value.replace(/\D/g, ''));
        return;
      }

      // Validate if we have enough digits for meaningful validation
      if (value && value.length >= 6) {
        this.perform_sa_id_validation(field, value);
      } else {
        // Clear validation if not enough digits
        this.clear_sa_id_validation(field.model);
      }
    },

    handle_sa_id_validation_input(field) {
      if (!field?.model) return;
      this.validate_sa_id_on_input(field);
    },

    validate_sa_id_on_blur(field) {
      const value = Reflect.get(this.safe_form_data, field.model);

      // Full validation on blur
      if (value && value.length === 13) {
        this.perform_sa_id_validation(field, value);
      } else if (value && field.required && value.length > 0 && value.length !== 13) {
        this.set_sa_id_validation_state(field.model, {
          hasError: true,
          message: 'SA ID must be exactly 13 digits',
          details: null,
        });
      }
    },

    handle_sa_id_validation_blur(field) {
      if (!field?.model) return;
      this.validate_sa_id_on_blur(field);
    },

    perform_sa_id_validation(field, value) {
      const validation = this.validate_sa_id_field(field, value);

      if (!validation.valid) {
        this.set_sa_id_validation_state(field.model, {
          hasError: true,
          message: validation.error,
          details: null,
        });

        // Also add to general validation errors if it's required
        if (field.required) {
          this.set_validation_error(field.model, validation.error);
        }
      } else {
        this.set_sa_id_validation_state(field.model, {
          hasError: false,
          message: null,
          details: validation.details,
        });

        // Clear general validation error
        this.clear_validation_error(field.model);
        this.apply_sa_id_derived_details(validation.details);
      }
    },

    clear_sa_id_validation(model) {
      this.set_sa_id_validation_state(model, {
        hasError: false,
        message: null,
        details: null,
      });
      this.clear_validation_error(model);
    },

    is_safe_form_model_key(model) {
      return typeof model === 'string' && /^q_\d+$/.test(model);
    },

    set_validation_error(model, message) {
      if (!this.is_safe_form_model_key(model)) return;
      Reflect.set(this.validation_errors, model, message);
    },

    clear_validation_error(model) {
      if (!this.is_safe_form_model_key(model)) return;
      Reflect.set(this.validation_errors, model, null);
    },

    set_sa_id_validation_state(model, { hasError = false, message = null, details = null } = {}) {
      if (!this.is_safe_form_model_key(model)) return;
      Reflect.set(this.sa_id_validation_errors, model, hasError);
      Reflect.set(this.sa_id_validation_messages, model, message);
      Reflect.set(this.sa_id_validation_details, model, details);
    },

    // ── Phone field methods (single field with country code) ──

    parse_phone_single_input(raw_value, fallback_code = '+27') {
      return parse_single_field_phone_input(raw_value, fallback_code);
    },

    get_phone_country_code(model) {
      return Reflect.get(this.phone_country_codes, model) || '+27';
    },

    get_phone_display(model) {
      const existing_value = Reflect.get(this.safe_form_data, model) || '';
      if (!Reflect.get(this.phone_raw_digits, model) && existing_value) {
        const parsed = this.parse_phone_single_input(existing_value, this.get_phone_country_code(model));
        Reflect.set(this.phone_country_codes, model, parsed.country_code);
        Reflect.set(this.phone_raw_digits, model, parsed.digits);
        return parsed.formatted;
      }

      const digits = Reflect.get(this.phone_raw_digits, model) || '';
      const cc = this.get_phone_country_code(model);
      if (!digits && !existing_value) return '';
      const formatted = format_phone_number(digits, cc);
      return digits ? `${cc} ${formatted}` : cc;
    },

    get_phone_placeholder() {
      return '+27 82 123 4567';
    },

    on_phone_input(event, field) {
      const raw = event.target.value || '';
      const parsed = this.parse_phone_single_input(raw, this.get_phone_country_code(field.model));

      Reflect.set(this.phone_country_codes, field.model, parsed.country_code);
      Reflect.set(this.phone_raw_digits, field.model, parsed.digits);
      Reflect.set(this.safe_form_data, field.model, parsed.formatted);

      event.target.value = parsed.formatted;

      // Clear error while typing
      if (parsed.digits.length < 3) {
        this.clear_validation_error(field.model);
      }
    },

    on_phone_blur(field) {
      const digits = Reflect.get(this.phone_raw_digits, field.model) || '';
      const cc = this.get_phone_country_code(field.model);

      if (!digits) {
        if (field.required) {
          this.set_validation_error(field.model, 'Phone number is required');
        }
        return;
      }

      const result = validate_phone(digits, cc);
      if (!result.valid) {
        this.set_validation_error(field.model, result.error);
      } else {
        Reflect.set(this.safe_form_data, field.model, result.formatted);
        this.clear_validation_error(field.model);
      }
    },

    normalize_prefilled_phone_field(field) {
      if (!field || !field.model) return;

      const is_phone_type = field.type === 'phone';
      const is_phone_label = /(phone|mobile|cell|telephone|tel\.?\s*no)/i.test(String(field.label || ''));
      const is_mapped_registration_phone = field.registration_source_mapping_id === 'phone_number';
      if (!is_phone_type && !is_phone_label && !is_mapped_registration_phone) return;

      const existing_value = String(Reflect.get(this.safe_form_data, field.model) || '').trim();
      if (!existing_value) return;

      const parsed = this.parse_phone_single_input(
        existing_value,
        this.get_phone_country_code(field.model)
      );

      Reflect.set(this.phone_country_codes, field.model, parsed.country_code);
      Reflect.set(this.phone_raw_digits, field.model, parsed.digits);
      Reflect.set(this.safe_form_data, field.model, parsed.formatted);
    },

    normalize_prefilled_phone_fields() {
      const sections = this.safe_form_config?.sections || [];

      sections.forEach((section) => {
        (section.fields || []).forEach((field) => {
          this.normalize_prefilled_phone_field(field);
        });
      });
    },

    // ── Contact field validation (fax, email, postal code, passport) ──

    validate_contact_on_input(field) {
      const value = Reflect.get(this.safe_form_data, field.model);

      // For fax/postal_code: strip non-digit chars on input (except + for intl prefix)
      const digits_only_types = ['fax', 'postal_code'];
      if (digits_only_types.includes(field.type)) {
        if (value && !/^[+\d\s\-()]*$/.test(value)) {
          Reflect.set(this.safe_form_data, field.model, value.replace(/[^+\d\s\-()]/g, ''));
          return;
        }
      }

      // For passport: strip invalid chars (only alphanumeric, hyphens, spaces)
      if (field.type === 'passport_number') {
        if (value && !/^[A-Za-z0-9\s-]*$/.test(value)) {
          Reflect.set(this.safe_form_data, field.model, value.replace(/[^A-Za-z0-9\s-]/g, ''));
          return;
        }
      }

      // Real-time validation only when user has typed enough
      if (!value || value.trim().length < 3) {
        this.clear_validation_error(field.model);
        return;
      }

      const result = validate_contact_field(field.type, value);
      if (!result.valid) {
        this.set_validation_error(field.model, result.error);
      } else {
        this.clear_validation_error(field.model);
      }
    },

    validate_contact_on_blur(field) {
      const value = Reflect.get(this.safe_form_data, field.model);

      if (!value || value.trim().length === 0) {
        if (field.required) {
          this.set_validation_error(field.model, 'This field is required');
        }
        return;
      }

      const result = validate_contact_field(field.type, value);
      if (!result.valid) {
        this.set_validation_error(field.model, result.error);
      } else {
        this.clear_validation_error(field.model);
      }
    },

    handle_contact_validation_input(field) {
      if (!field?.model) return;
      this.validate_contact_on_input(field);
    },

    handle_contact_validation_blur(field) {
      if (!field?.model) return;
      this.validate_contact_on_blur(field);
    },

    is_contact_field_type(type) {
      return CONTACT_FIELD_TYPES.has(type);
    },
  }
};

